var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanLaundryBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 215,
    viewBox: "0 0 240 215",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a0qhkaxvza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024 0v768H0V0h1024z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mucpynmcwb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.474.03c2.758.803.099 13.563 7.018 15.79 5.767 1.856 10.893-1.217 16.793.301 1.197.308 2.974.866 4.812 1.153.95.148 3.294.27 4.461.15 2.455-.251 6.467-.35 8.822 0l1.254-.3c.15 4.661.019 7.784-.351 8.421-1.117 1.927-2.716 3.4-5.213 5.213-4.62 3.354-10.588 4.4-15.64 5.664-6.366 1.594-12.423 1.4-18.948 1.053-6.287-.333-11.838-2.316-17.494-4.762C6 30.989 1.516 27.35 1.002 25.85c-.92-2.677-1.264-6.361-.79-9.228.738-4.454 3.27-7.972 6.969-10.578C10.533 3.687 23.013-.395 24.474.031z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qopxdqf2pc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.221 6.622c2.054 3.174 2.049 6.385 3.39 9.584 3.32.43 5.997-1.44 7.194 3.043.836 3.135 2.027 5.922-.061 8.22-1.417 1.56-1.575 2.008-.552 3.91.691 1.287-1 2.502-.146 3.715.716 1.012 1.81 1.898 2.402 2.953.688 1.223.688 2.97.762 4.46.17 3.418.493 6.457-3.012 7.425-2.813.777-6.207 1.625-8.961 2.467-.827.253-3.445 1.526-4.211 1.27-.602-.2-.268-3.495-.268-4.946v-1.775c.007-2.691.051-5.484.37-8.019-4.958-.251-8.601-.517-10.2-5.85-1.185-3.948-.608-8.471-.827-12.797-1.019-.059-3.076-.133-3.78-.967-1.05-1.244.72-1.264 1.804-1.87 2.273-1.27 2.808-2.34 3.21-4.746.732-4.399 2.33-8.66 5.413-11.83L11.55 0c2.42 1.91 4.93 3.93 6.671 6.622z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "len0rrvrvd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.955 7.544c-1.467-6.321 4.8-9.297 10.798-6.477 1.036.488 1.823.961 2.808 1.414 1.077.496 2.801.588 3.728 1.083 2.61 1.395 2.586 4.476 1.142 5.637 6.127 7.908-2.834 10.87-7.821 10.745 1.569 3.932 1.234 12.965-.159 16.923-1.088 3.092-10.424 12.42-12.431 10.955-1.855-1.353-4.512-6.817-5.564-9.674-.233-.631 1.68-.755 2.907-4.06 1.713-4.615-.482-7.405-3.359-8.181-1.74-.47-3.15.671-4.812-.268C7.786 24.28 1.637 16.529 0 11.313L2.172 9.6c8.087-6.438 16.542-3.732 20.783-2.056z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sbij8larve"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.953 0c1.241 1.083 2.011 2.602 2.739 4.165l.362.783c.846 1.828 1.731 3.627 3.336 4.774 1.532-1.826-.042-4.811 1.995-6.503 3.905 3.744 1.233 10.846 5.313 15.177 1.765 1.875 4.341 2.847 6.238 4.61 2.02 1.878 3.364 4.33 5.612 5.874.234-3.551.08-7.204.08-10.785l.402.4c4.072.128 8.86-.157 13.172.06-.303 5.406-1.382 10.904-2.657 16.07-.1.404-.2.818-.305 1.237l-.105.42-.109.421c-1.25 4.79-3.193 9.755-9.694 7.556-4.356-1.473-9.059-8.366-11.83-11.828-3.215-4.015-5.892-8.965-9.726-12.643C8.046 17.169-.217 13.065.008 8.933c1.143.345 1.882.26 2.786 1.383a27.377 27.377 0 0 0-.761-.986l-.315-.397C.775 7.733-.1 6.469.009 4.923c1.31.056 2.448.624 3.388 1.58a8.094 8.094 0 0 1-.973-5.6c1.368.685 3.142 3.829 3.537 4.82C5.604 3.788 4.53 1.623 5.953 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "65lpmant4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.447c.849-1.44 4.255-4.25 4.42-.792.144 3.034-3.206 3.182-4.42.792z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9m9eo4omrg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.707.33c1.27.601 5.152 3.445 7.018 4.875l.544.416.271.207.543.413c4.148 3.158 8.028 6.057 8.066 6.784.131 2.485.222 9.57.227 17.69v1.064c0 .892-.001 1.794-.004 2.702l-.003 1.092-.005 1.096-.009 1.647-.007 1.097c-.043 5.85-.135 11.6-.292 16.053-.12 3.381-.428 9.49-.815 15.612l-.059.918-.06.916c-.562 8.536-1.256 16.566-1.78 16.64-5.302.76-15.96 2.228-20.219-.901-3.936-2.893-7.579-6.255-11.177-9.576C.47 76.792-.55 78.104.29 75.416c.677-2.168 3.449-5.7 4.11-7.92 1.527-5.124 1.186-10.745 2.468-15.98 2.072-.105 2.879.145 4.951.04.64-3.671.594-8.326.401-12.198-.221-4.46.117-9.029.335-13.5.392-8.071-1.744-16.075-1.471-24.329l.134-1.441C12.2.08 13.423.048 14.665.024l.678-.011C17.713-.023 20.01 0 20.707.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sd5pl3vhqh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.287 3.796c3.492 2.783 5.694 6.716 9.975 8.019 4.46 1.356 10.155.152 14.805.492-.092.593-.398.082-.77.312l5.214.4c4.125 2.334 2.578 11.828 2.336 15.99-.541-.03-3.032-1.465-3.54-1.82.435-5.331-5.14-7.786-9.624-5.748-2.505 1.139-2.926 2.016-5.614 2.807-2.721.8-4.15.722-6.115 3.149-5.12-2.21-6.932-1.308-9.193 3.599-4.94-.35-6.292 2.57-6.417 6.847-2.53.344-2.963 2.072-3.11 4.381-3.597 1.223-8.425 1.013-12.4.812-.661-4.05-5.986-7.389-10.017-8.43-2.376-3.517-5.682-3.24-8.69-1.435-.192.115-2.213-.267-3.208-.702-1.704-3.71-4.993-3.131-7.529-2.315-2.187.706-2.932 1.43-5.504 1.713-1.942.215-5.09-.092-6.917 0-.473-3.229-4.059-3.457-4.813-4.21-.601-.602-.146-3.387-1.993-4.903C2.832 21.662 1.379 21.713 0 20.649c1.527-2.631.914-7.297 1.113-10.367 4.342-1.137 15.42-1.812 26.76-2.42l1.547-.082c13.93-.738 27.81-1.401 29.672-2.719 3.03 3.716 6.136.262 9.212-2.866l.318-.323c.265-.267.53-.53.795-.783 2.406-2.305 3.545-.738 7.87 2.707z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17lrubxkoi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.318.007.802.1c-1.146 1.1-2.45 3.042-3.99 3.638-1.384.535-5.84.699-7.64.874-4.496.435-8.8.175-13.233 1.08-4.713.963-9.782.844-14.435 2.028-3.532.898-6.258 5.2-9.544 5.574-1.693-9.912 4.62-11.51 11.51-12.03l.56-.04c2.243-.151 4.526-.21 6.596-.422C25.663.12 33.83.01 41.004.001h1.93c1.901 0 3.713.006 5.384.006z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tnj5noay7j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.161 0c.137 1.857-.126 3.433-.81 5.082C-.22 5.01-.362 2.305.414.342h-.4C.093.296 2.181-.016 3.16 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ktx58p5qak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.775 0a.601.601 0 0 1 .59.557c.142 1.936-.121 3.588-.854 5.356a.602.602 0 0 1-.555.372h-.017C1.602 6.246.899 5.599.545 5.063c-.69-1.048-.64-2.476-.314-3.66A.604.604 0 0 1 .33.414C.628.253 2.986.007 3.775 0zm-.581 1.221c-.546.035-1.211.115-1.705.184-.396 1.153-.377 2.332.06 2.995.227.343.56.555 1.013.64a9.837 9.837 0 0 0 .632-3.819z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0gl2hwwxbl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.253 0C4.33 3.608 4.785 8.454 7.768 12.59c2.788 3.866 7.35 4.04 11.888 3.795l.648-.037.324-.02.645-.042.321-.022.64-.041a49.398 49.398 0 0 1 3.101-.124h1.18c-.096 2.936.883 5.942-.5 8.622-4.264.25-7.636-.412-11.83-.2-4.231.213-9.125 1.862-10.126-2.808-.602-2.807-.733-7.106-1.704-10.827-.256-.98-.72-2.325-1.167-3.735l-.149-.472C.033 3.443-.769.04 1.253 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u6bzdi4idm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.65 0c3.465 13.37.755 28.248.04 42.347-4.09.22-9.564.461-14.276.461-1.164 0-3.375.045-3.81.401-.882.723-.05 3.138-.3 5.615-.253 2.497.224 5.012 0 5.012-.228 0-2.777-2.642-5.31-5.318l-.46-.486c-1.76-1.862-3.441-3.663-4.256-4.52C1.715 39.759-.575 36.567.126 30.829c3.142 1.016 4.386-.406 6.244-2.569 1.298-1.509 3.924-3.885 4.825-5.602 2.295-4.376-1.257-2.118-4.705.157l-.327.217-.326.215c-1.787 1.18-3.44 2.248-4.107 2.256-.098-1.529-1.313-2.909-1.642-4.29 7.596 1.144 16.62-8.48 16.018-15.699v-.401C19.916 4.511 28.353.889 33.65 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4tjqh1ztjn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.987 0c2.286.102 3.683.273 6.116.401.756 2.368.098 5.896 1.504 7.82C13.91 5.514 14.512 2.707 16.116.6l.1-.4.076.105c.475.65 2.466 3.317 4.552 6.035l.432.563c1.66 2.154 3.316 4.256 4.263 5.327 4.554 5.148 7.72 9.624 13.062 9.693-.106.898-.678 2.087-1.295 3.302l-.373.73c-.557 1.092-1.082 2.163-1.268 3.017-7.443-2.505-15.531-5.397-21.855-9.724C10 16.642 4.386 11.93 1.679 7.719.922 6.542-.181 6.088.025 5.264.326 4.06 3.693 1.193 4.987 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "npeqiw38xo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.477 0c-.5 1.042.105 3.1 4.112 8.06 1.955 2.42 5.453 4.461 7.92 6.215 5.567 3.96 10.756 6.794 17.144 8.622-5.173 5.922-20.87 3.301-28.272 3.51-10.727.3-19.952-.155-30.116.36-.562 3.85-.762 8.361-.922 11.51-2.547-.141-7.944-.75-11.77-.943-.39-3.354-.25-7.036-.802-10.427-9.524 0-17.522.21-26.467-.2-4.759-.22-10.182.407-15.039.1-3.539-.223-2.804-.561-3.208-4.11-.24-2.108.343-4.695.462-6.908 5.955-.712 11.059-1.16 15.99-1.905 6.07-.92 12.38-2.296 18.526-3.129 2.311-.313 8.392.864 9.054-1.372.481-1.624 1.936-2.793 4.592-3.93C54.174 3.1 62.304 2.83 68.23 2.245c6.577-.65 12.78-1.203 19.649-1.203L86.677.64c.332-.176.6-.271.8-.641z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u6vt00tywp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.561 2.268c1.805-2.556 7.692-3.682 10.126.602-.15 3.358.125 6.252-2.397 7.642-2.873 1.584-6.195.552-7.315-1.94C.068 6.554-.469 3.728.561 2.268z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bmfi2ef3nq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.075.364C9.29-.977 21.622 1.537 29.69 5.517h-2.006c-1.215.387-4.716 1.1-8.166 1.652-.45.071-.276.89-.745.957-.366.05-.738.099-1.112.142l-.565.062C8.781 9.195-.95 7.974.075.364z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crg960ze5r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.415 1.673C2.633-.37 8.335-.633 10.92 1.393c.153 2.613.07 5.307.07 7.95l-.802-.401c-1.854-1.554-7.007-2.042-9.123.34C-.037 7.387-.336 2.364.415 1.672z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64moxgxc5s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.596 8.431c5.771-13.41 29.474-6.967 32.03-6.316l-.601.35c6.045 1.342 9.393 5.744 8.572 9.526-.672 3.09-4.543 5.496-8.572 7.719C24.757 23.72-4.517 20.31.595 8.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ymiwdx9ptt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.332 6.026c1.51 2.054 1.629 5.575 3.3 6.855 2.37-1.658 6.188-4.527 8.046-.849-1.477 2.265-4.364 7.163-7.667 6.424-.614-.137-1.15-.809-1.655-1.508l-.25-.35c-.578-.809-1.123-1.54-1.705-1.388-1.562.409-.356 3.766-1.985 4.89-2.063-1.324-2.864-3.65-3.674-5.904l-.222-.612a23.005 23.005 0 0 0-.595-1.484c-.51-.031-.958-.053-1.475-.01-.157 1.202-.606 2.216-.55 3.52-.582-1.191-1.697-2.545-3.037-3.138.054.362.055.708.047 1.048l-.012.508c-.007.507.02 1.014.236 1.56-.622-.302-1.639-.068-2.297-.288-.241 1.501.137 2.83.992 4.067-.493.04-1.189.345-1.794.344-.217 2.375 3.241 4.895 6.69 7.474l.625.47c2.6 1.958 5.068 3.947 5.799 5.93-1.32 1.035-1.91 2.555-2.433 4.095l-.222.66c-.407 1.206-.831 2.383-1.596 3.304-.894-2.259-.918-4.926-.964-7.497-9.803.476-12.772-7.279-9.876-16.101C3.54 10.49 9.792 2.673 13 1.604L13.802 0c-.238 3.132 1.926 3.842 3.53 6.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wzcl0x8rtu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.978 0 .401.401c1.263 5.545 4.084 7.674 10.768 7.278-.227 3.424-.823 7.463-.943 8.06-.158.795-3.882 1.188-7.6 1.56l-.586.058c-.78.078-1.552.155-2.282.236C1.381 13.768-2.132.802 1.978 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7jty2urpv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.669 0c5.523-.09 3.172 9.26 3.384 12.425C35 9.417 34.77 20.567 34.33 23.252c.765-1.557 4.946-13.676 8.556-10.159 3.043 2.966-2.309 13.94-2.406 17.244 2.994-2.584 5.659-2.155 4.678 2.005-.79 3.354-2.509 6.54-3.61 8.555-2.32 4.247-6.365 7.815-7.752 11.63v.4c-1.163.445-2.555.578-4.002.668l-.513.03c-3.6.206-7.41.342-8.798 4.456-2.015-.465-6.636.052-8.442-1.143-2.026-1.34-2.966-5.686-4.01-8.01C5.819 44 4.273 38.405 2.907 33.289 1.698 28.753-1.523 19.633.85 15.222c2.752-5.11 5.331-2.074 7.133 1.274l.164.31c.755 1.448 1.363 2.909 1.774 3.757l.085.172.04.078c.865-4.546.114-12.317 3.198-16.019 1.649-1.978 1.656-3.507 3.842-1.593 2.002 1.753 4.413 9.696 4.417 12.164.469-2.843 1.132-15.299 5.165-15.365z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qspxkwof2w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.12.148.397.253c6.345.274 8.935 6.43 8.271 12.081-.18 1.54-1.3 2.392-1.704 3.809-.931 3.258-1.455 6.94-2.167 10.557-1.151 5.843-1.133 9.941-6.806 13.165-4.601 2.613-10.342 4.106-15.64 4.9-12.02 1.805-25.312-.425-35.59-6.215-5.763-3.247-5.514-8.923-7.018-15.138-.537-2.22-1.736-5.64-2.005-7.018-.253-1.3-1.292-2.525-1.504-3.81-.405-2.45-.802-5.714.87-7.068 1.896.595 2.517 2.808 2.977 5.098l.108.55.053.275.105.546c.265 1.356.552 2.628 1.102 3.485 2.089 3.25 6.514 3.355 10.113 3.943 12.216 1.992 26.379 3.578 38.899.98 3.879-.805 13.054-3.088 14.847-7.209C71.613 8.308 64.065 2.758 64.116 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dxipsswizx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.953 3.985c.89 1.53 1.291 6.916.402 6.015L5.15 12.406c.438-3.19-1.07-5.196-2.567-7.107l-.357-.458C1.1 3.394.072 1.951 0 .034c2.741-.327 4.69 1.779 5.953 3.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zo5riny6fy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.595 0C2.028 13.018 22.374 3.78 27.184 4.07c-1.052 4.604 6.999 3.602 10.086 3.168 5.652-.793 4.896-2.646 4.872-7.176 7.401.507 16.898 15.846 8.872 20.9-2.232 1.407-6.59.883-9.244 1.183-3.118.353-6.376.716-9.713.713-6.732-.007-13.39 1.057-20.051.4-5.927-.583-8.353-5.305-10.738-10.524C-1.775 6.074.892 3.004 6.793 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ucohhuz3jz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.3.522.007.28c3.69 2.516 2.147 8.382 1.604 12.03-.873 5.866-.067 12.324-2.607 17.545-1.805 3.71-6.235 13.813-9.624 17.444-2.808 3.008-8.393.719-14.437-.1-6.445-.873-13.263-1.804-19.44-2.795-6.237-1.002-11.852-1.968-18.367-2.507-5.045-.418-14.763-2.67-18.837-5.726-.103-.078-.315-1.45-.575-3.49l-.076-.6c-.242-1.957-.52-4.412-.787-6.902l-.085-.787C.56 20.06.098 15.256.018 13.922c-.234-3.88 1.88-6.002 3.684-8.346 2.613 1.817-.958 6.155.4 9.263 1.252 2.864 3.84 4.217 7.309 5.121 6.894 1.798 14.603 1.31 21.654 2.007 12.513 1.237 24.393 5.667 37.607 5.703 4.584.013 4.938-.36 6.718-4.422 1.18-2.694 2.497-5.172 4.02-7.707 1.094-1.82 3.873-4.649 4.13-6.73.106-.863-1.076-2.942-1.233-3.999-.227-1.527 0-3.266 0-4.812z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pwkm62axzA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.174 0c.955.546 1.507 1.671.968 2.773-.943.379-2.106.256-3.142.205C.077 1.903 1.013.718 1.773 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fke14zpjcB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.268 36.452-.018.018c-.513.479-3.235 2.816-4.2 3.638-1.478 1.264-1.713 2.561-3.34 3.142-3.178 1.132-10.912-.018-14.504-.2-.402-7.932-1.203-16.231-1.203-24.262C1.003 14.942.2 8.428 0 4.552c-.013-.275 1-.73 4.21-1.003 1.959-.166 3.305-.903 3.209 1.538C7.717 3.22 8.66 1.79 9.357.007c2.494-.198 1.742 3.905.707 7.846l-.14.524c-.679 2.525-1.422 4.9-1.435 5.933-.076 5.813 1.47 12.9 1.938 18.58 3.395.28 7.539.306 10.96.134-.301-2.238.92-4.863 3.342-4.411 1.738-11.295 19.99-13.436 21.254-.134.593 6.239-2.138 10.402-7.084 13.635-1.388.907-5.416 2.34-7.016 2.257-2.16-.11-3.761-2.818-5.948-3.597-.082-1.423-1.39-2.426-1.406-3.874l-.261-.448z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vdcptchtnC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 2.049c.592.387.898.464 1.002.802l-.602-.2c3.086 1.323 7.887.267 10.994.637.113 1.751.073 6.39-.06 11.051l-.027.874c-.163 5.234-.44 10.27-.747 11.031-2.706.102-5.748.334-8.52.242-.055-.838.287-3.71-1.038-3.804-.978-.07-2.08 3.16-2.272 3.896-3.118.057-5.949.401-8.956.555C.67 25.91.024 4.761.001 3.253-.03 1.235.475.702 2.403.238 5.31-.459 8.57.441 11.029 2.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4aq5ayxexD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.293 0c18.909 0 34.293 8.043 34.293 17.93 0 9.886-15.384 17.928-34.293 17.928C15.383 35.858 0 27.816 0 17.93 0 8.043 15.384 0 34.293 0zm0 1.203c-18.246 0-33.09 7.503-33.09 16.726 0 9.223 14.844 16.726 33.09 16.726 18.246 0 33.09-7.503 33.09-16.726 0-9.223-14.844-16.726-33.09-16.726z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j8201ynhbE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.056.208c6.978 8.066 18.346 12.194 33.788 12.269h.132c6.362 0 25.482-2.214 32.381-12.197a.6.6 0 1 1 .99.684c-3.153 4.563-8.872 8.034-16.996 10.32-6.305 1.772-12.71 2.396-16.358 2.396h-.154C19.033 13.603 7.36 9.335.147.995a.602.602 0 1 1 .91-.787z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j0sz7nb7iF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.054 0c11.609 0 21.053 5.067 21.053 11.296 0 6.228-9.444 11.295-21.053 11.295C9.444 22.59 0 17.524 0 11.296 0 5.067 9.445 0 21.054 0zm0 1.203c-10.946 0-19.851 4.528-19.851 10.093 0 5.564 8.905 10.092 19.851 10.092 10.945 0 19.85-4.528 19.85-10.092 0-5.565-8.905-10.093-19.85-10.093z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "he3svxwctG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.194.494c2.835 15.632 12.02 28.178 14.55 30.026a.6.6 0 1 1-.71.971C12.035 29.302 2.877 16.521.01.709A.601.601 0 1 1 1.194.494z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j3eihqt6vH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18.434C3.684 9.038 8.666 19.67 14.847 29.607a.601.601 0 1 1-1.02.636C7.588 20.217 2.556 9.475.023.77A.601.601 0 0 1 1.18.434z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8od1jg7evI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.563.001c.33-.018.618.23.64.561.507 7.864 3.6 15.678 6.086 21.957.585 1.477 1.14 2.882 1.63 4.198a.602.602 0 0 1-1.128.418c-.486-1.309-1.04-2.704-1.62-4.173C3.653 16.604.52 8.692 0 .64A.601.601 0 0 1 .563.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j9bkvy52zJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.768.448c.74.153.775 19.136.297 38.195l-.06 2.287c-.497 18.274-1.459 35.926-2.714 36.363-.584.204-6.598.356-11.562.366h-.736c-3.268-.003-5.91-.073-5.934-.239-.56-4.047 2.99-76.036 5.53-77.373h-.133C5.722.02 6.529.003 7.646 0h.893c4.086.012 10.825.159 12.23.448z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "elmiaafdtK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.559.048.758.015c3.154.07 6.21.197 7.172.395.548.113.698.61.843 2.8.31 4.692.323 16.59.072 29.693l-.023 1.194c-.016.798-.034 1.6-.052 2.404l-.027 1.209-.015.605-.03 1.212-.048 1.82-.068 2.423-.036 1.21c-.974 31.75-2.33 33.163-2.96 33.411l-.038.015-.019.006c-.453.158-5.247.34-9.876.392l-.644.007c-.536.004-1.066.007-1.584.008h-.31c-3.239 0-5.936-.084-6.31-.313a.668.668 0 0 1-.302-.453c-.038-.276-.058-.843-.061-1.661v-.606c.018-4.445.403-14.392.98-25.494l.057-1.078c.038-.72.076-1.446.116-2.174l.06-1.094.091-1.648.063-1.102.16-2.76c.043-.735.087-1.47.132-2.204C3.45 8.862 4.73 2.28 5.455.674a.6.6 0 0 1 .537-.626C6.258.02 7.146.003 8.375 0h.902c1.265.004 2.766.02 4.282.048zM8.902 1.202h-.678a59.37 59.37 0 0 0-1.738.021C4.37 5.204.779 70.32 1.217 77.534c.834.084 2.958.122 5.452.124h.799c4.584-.009 10.046-.13 11.122-.314.797-1.459 1.855-13.625 2.469-37.94.216-8.581.314-16.235.321-22.391v-1.296c-.007-7.777-.168-12.914-.425-14.128-1.16-.154-4.098-.263-7.063-.326l-.889-.017a271.48 271.48 0 0 0-4.1-.044z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qs2622tnlL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.56 0a.608.608 0 0 1 .641.56c.078 1.14.33 3.275.546 4.824l.089.624c.043.289.082.54.117.74a.6.6 0 0 1 .186.436c0 .561-.206.852-.61.867h-.056C.876 8.051.827 7.67.45 4.76.273 3.408.067 1.61 0 .64a.601.601 0 0 1 .56-.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x3rmoheyoM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.535C1.626 4.372 2.893 8.803 4.965 13.7a.6.6 0 1 1-1.107.468C1.739 9.164.443 4.622.004.668A.601.601 0 0 1 1.2.535z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yk83n7h2aN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.75.052c4.465.014 8.208.026 10.72.028h.85a.602.602 0 0 1 0 1.204h-.85c-2.513-.003-6.258-.015-10.723-.029-5.616-.017-13.114-.04-20.84-.048l-1.499-.002-1.5-.001h-1.502l-.75-.001h-2.243c-14.659.004-28.215.082-29.274.368-.777.4-1.754 4.947-1.913 12.54-.192 9.147.824 14.833 1.6 15.267.093-.003.262-.005.5-.005h.735c.816.002 1.986.008 3.446.016 17.909.095 32.918.144 44.993.15h4.025c19.876-.01 30.83-.154 32.688-.433.31-.065 1.363-1.614 2.08-7.684 1.103-9.342.34-19.022-1.57-19.918a.601.601 0 1 1 .51-1.088c3.335 1.563 3.116 15.37 2.055 22.66-1.008 6.935-2.43 7.15-2.897 7.22-2.203.332-16.244.439-32.48.45h-5.817l-2.36-.003-1.577-.002-.79-.001-1.58-.003c-14.743-.026-29.368-.103-37.286-.145-2.171-.012-3.701-.02-4.408-.022h-.187l-.136-.001c-1.055 0-1.53-1.426-1.827-2.67-.757-3.175-1.106-9.404-.87-15.5C.265 7.459.87 1.378 2.656.474 3.281.157 10.851.012 30.42.001h5.222c7.008.004 15.32.021 25.108.051z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e9axkc1uO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.012.505 2.406 14.838a.6.6 0 0 1-.593.698h-3.61a.6.6 0 0 1-.562-.389L.04.815A.602.602 0 0 1 1.164.388l5.468 14.45h2.485L6.825.698A.6.6 0 1 1 8.012.505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8g5kbl80P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.608.036a.602.602 0 0 1 .361.77L4.611 15.644a.6.6 0 0 1-.565.397H.601a.6.6 0 0 1-.594-.693L2.303.51a.601.601 0 1 1 1.19.183l-2.19 14.145h2.321L8.838.398a.6.6 0 0 1 .77-.362z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w6pcn8u3aQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.625.533a.6.6 0 0 1-.53.665c-1.302.147-3.54.292-6.37.477-3.153.204-7.576.492-12.234.921l-.934.088c-.937.09-1.88.185-2.822.287l-.941.104C10.396 4.135 1.44 5.843 1.202 8.67a.603.603 0 0 1-1.2-.1C.392 3.958 14.597 2.104 29.805.95l1.05-.078a539.1 539.1 0 0 1 1.58-.114l1.054-.073a811.76 811.76 0 0 1 3.158-.211c2.816-.184 5.04-.328 6.314-.47.328-.034.628.199.664.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7wseq49cR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.611 0c.332.01.593.288.584.62-.195 6.298-.458 11.143-.735 16.273-.1 1.837-.2 3.704-.3 5.68a.604.604 0 0 1-.602.571h-.033c-2.104-.114-3.662-.084-5.313-.052-1.598.03-3.25.063-5.425-.05a.602.602 0 0 1-.57-.57C.965 17.502.78 14.358.573 10.787.412 8.023.235 5.005 0 .69A.601.601 0 0 1 .569.056a.598.598 0 0 1 .633.568c.235 4.313.411 7.33.572 10.092.2 3.442.379 6.488.617 11.15 1.87.08 3.357.05 4.798.023 1.447-.028 2.938-.058 4.8.024.089-1.758.18-3.433.27-5.085.277-5.123.538-9.961.733-16.246.01-.332.26-.584.62-.582z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66dwzlqveS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.803 0a.6.6 0 0 1 .586.617c-.094 3.64-.097 5.865-.01 9.157.013.458.042.998.074 1.572.114 2.09.243 4.456-.266 5.52a.588.588 0 0 1-.066.108c-1.08 1.405-3.088 1.065-5.213.71-1.06-.179-2.155-.36-3.126-.325-.629.027-1.097.004-1.511-.015-.667-.031-1.192-.055-2.136.137-2.399.492-6.929.985-10.58.985-2.862 0-5.183-.303-5.513-1.15a.601.601 0 0 1-.037-.3c.386-2.793 4.025-3.31 7.544-3.809 1.977-.28 4.02-.57 5.23-1.25 4.87-2.738 5.04-6.635 5.238-11.149l.007-.183c.015-.331.302-.605.628-.574a.601.601 0 0 1 .574.627l-.008.183c-.011.258-.022.516-.035.774l-.026.517c-.221 4.046-.86 8.083-5.788 10.853-1.407.792-3.565 1.098-5.651 1.394-2.908.412-5.909.838-6.451 2.48 1.43.615 9.082.557 14.627-.575 1.09-.225 1.712-.195 2.432-.161.408.018.831.036 1.408.015 1.091-.05 2.254.15 3.374.339 1.723.29 3.352.565 4.019-.207.345-.841.217-3.168.124-4.878a62.58 62.58 0 0 1-.074-1.606c-.087-3.275-.085-5.602.01-9.22A.603.603 0 0 1 27.802 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2z9599xvkT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98 11.452c4.59 7.46 13.356 4.053 18.368 4.654l.007 8.527c-1.633.126-6.106.003-11.235-.105-3.054-.065-6.834.398-7.632 0-1.677-.84-2.45-2.062-2.45-4.254C4.037 17.868 1.44 6.65.682 4.567-.119 2.36-.264.362.512.066c2.282-.912 4.33 7.91 6.469 11.386z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9gd4thvshU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.065.132c1.448.626 2.56 3.452 3.85 6.724.717 1.823 1.46 3.71 2.182 4.883 3.2 5.198 8.541 4.801 13.258 4.452 1.697-.126 3.302-.245 4.669-.08.33.04.564.338.525.668a.608.608 0 0 1-.669.526c-1.25-.15-2.797-.036-4.436.086-4.807.356-10.789.801-14.372-5.022-.667-1.083-1.322-2.66-1.96-4.268l-.317-.804c-.988-2.51-2.219-5.633-3.207-6.06a.3.3 0 0 0-.25-.012c-.181.166-.305 1.484.514 3.737.772 2.121 3.39 13.41 3.39 15.914 0 1.911.595 2.953 2.118 3.715.35.166 2.107.089 3.52.026 1.22-.055 2.603-.114 3.856-.09l2.044.045c4.159.091 7.75.17 9.133.063.32-.018.62.222.646.553a.603.603 0 0 1-.554.647c-1.443.109-4.889.035-9.251-.06l-2.043-.044c-1.219-.024-2.577.035-3.777.088-.977.043-1.76.075-2.384.075-.841 0-1.39-.058-1.728-.227-1.925-.962-2.783-2.44-2.783-4.791 0-2.237-2.512-13.288-3.318-15.503C-.08 3.166-.455.623.901.106c.373-.15.777-.14 1.164.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "05fe79ekjV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.399.012A.602.602 0 0 1 6.87.72c-.058.292-.098.64-.143 1.028-.057.487-.122 1.04-.235 1.638-.436 2.311-1.39 2.748-2.598 3.302-.433.198-.921.423-1.474.772-.863.545-1.116.87-1.189.999l-.02.041a.119.119 0 0 0-.008.024c.177.273 1.745.592 2.587.763l.593.123a.602.602 0 0 1 .476.559c.06 1.226.038 2.521.014 3.892l-.016.929-.007.62c-.046 4.745.27 9.391 4.276 11.67.864.49 3.133.743 6.719.725.17 0 .34.075.453.198.335.363.11 4.953-.21 9.56l-.047.673c-.128 1.795-.266 3.56-.388 5.047a.6.6 0 0 1-.598.553c-.017 0-.033 0-.05-.002a.601.601 0 0 1-.55-.648c.124-1.527.276-3.597.416-5.701l.053-.79c.214-3.287.39-6.499.383-7.687-2.402-.009-5.461-.135-6.776-.882-4.406-2.507-4.896-7.422-4.887-12.18l.004-.606c.004-.504.013-1.005.022-1.5.02-1.176.04-2.295.006-3.348l-.126-.025C1.761 10.102.215 9.788.02 8.717c-.17-.924.851-1.7 1.76-2.275.62-.39 1.171-.644 1.614-.847 1.13-.518 1.597-.733 1.918-2.432.104-.558.167-1.087.222-1.555.05-.424.094-.803.158-1.123A.6.6 0 0 1 6.4.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bpw1wi0dbW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.943.005c.33.04.563.342.522.671-.066.528-.098 1.093-.132 1.692a32.673 32.673 0 0 1-.134 1.776.601.601 0 1 1-1.195-.133C.068 3.435.1 2.86.132 2.3c.035-.619.07-1.203.14-1.772A.602.602 0 0 1 .943.005z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gapcfeyuqX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.271.145a.6.6 0 0 1 .065.848c-1.654 1.93-2.83 2.368-4.57 2.86a.602.602 0 0 1-.327-1.158c1.42-.401 2.448-.691 3.984-2.485a.6.6 0 0 1 .848-.065z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pj6oikyy4Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6.002a.602.602 0 0 1 .593.61c-.005.333-.271.62-.61.593C5.346 1.025 1.494 12.292 1.2 15.093a.602.602 0 0 1-1.197-.126C.318 11.974 4.386 0 17.277 0c.108 0 .215 0 .324.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s7sj0vfv9Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61 1.456c1.781 1.61 2.344 4.284 1.544 7.335-.922 3.515-4.318 5.925-7.995 5.925a8.37 8.37 0 0 1-1.678-.169.602.602 0 0 1 .241-1.179c3.654.748 7.367-1.443 8.268-4.883.682-2.6.25-4.837-1.188-6.136C6.423 1.104 4.27.857 2.043 1.69A.6.6 0 1 1 1.622.563c2.657-.992 5.269-.658 6.987.894z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6atytxk2uaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23.295a.602.602 0 0 1-.211.823c-.817.484-1.535.849-2.169 1.17-.715.363-1.332.677-1.913 1.067a.598.598 0 0 1-.834-.164.602.602 0 0 1 .163-.835c.642-.43 1.289-.76 2.04-1.14C2.923.903 3.623.547 4.404.084a.604.604 0 0 1 .826.21z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "60clemkjyab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.021 9.713c4.585 7.155 4.302 17.196 1.652 23.418-2.026 4.754-6.945 7.765-11.55 10.077-.104.817-.126 3.735-.146 6.334-.01 1.273-.02 2.608-.038 3.894a.602.602 0 0 1-1.203-.018c.018-1.282.028-2.614.038-3.885.052-7.022.103-7.046.58-7.285 4.475-2.23 9.304-5.113 11.21-9.589 2.466-5.785 2.758-15.566-1.556-22.297l-.291-.45C14.59 5.128 10.786.968.617 1.216A.599.599 0 0 1 0 .629.604.604 0 0 1 .587.013c11.12-.288 15.054 4.43 18.434 9.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "32bl2qf3eac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.955 0v20.852H0V0h21.955z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vah76inoaad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.407.918c.526.263.91.611 1.248.919.353.322.659.6 1.097.782.473.197.976.314 1.508.437.826.192 1.68.39 2.467.909 2.036 1.34 2.64 3.7 1.576 5.974a6.073 6.073 0 0 1 1.615 4.83c-.217 1.95-1.382 3.658-3.195 4.683-1.586.897-3.725 1.4-5.78 1.4-.558 0-1.111-.037-1.644-.114a.602.602 0 1 1 .17-1.19c2.215.317 4.89-.142 6.662-1.143 1.494-.846 2.415-2.184 2.592-3.77a4.866 4.866 0 0 0-1.56-4.132.601.601 0 0 1-.121-.74c1.047-1.869.673-3.706-.976-4.793-.607-.4-1.322-.566-2.078-.742-.556-.13-1.133-.263-1.698-.498-.631-.262-1.064-.656-1.446-1.004-.307-.28-.597-.543-.975-.733C9.845.981 6.602.925 3.982 1.858c-1.28.455-2.291 1.47-2.643 2.65-.209.698-.281 1.761.557 2.866a.602.602 0 0 1-.96.728C.047 6.925-.22 5.526.187 4.164.653 2.6 1.921 1.314 3.578.724c2.906-1.033 6.536-.954 8.83.194z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5tnynfiwnae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.736 0c.332 0 .601.27.601.602 0 .145.005.316.01.498.029 1.063.025 1.736-.26 2.127a.6.6 0 0 1-.839.133.6.6 0 0 1-.132-.84c.061-.165.039-.99.029-1.387C.139.938.135.756.135.602.134.269.403 0 .734 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j6xvv930uaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6.084c1.546 3.24 1.612 6.783.192 10.246-1.772 4.321-5.777 8.059-10.452 9.753-.666.242-1.713.355-2.665.355-.55 0-1.068-.038-1.464-.11C2.344 25.41.21 20.399 0 17.255a.602.602 0 0 1 .56-.641.606.606 0 0 1 .64.56c.186 2.769 2.035 7.177 6.376 7.97.89.162 2.68.107 3.503-.192 4.366-1.583 8.102-5.061 9.75-9.079 1.286-3.14 1.23-6.346-.165-9.271C19.208 3.545 15.878.555 10.91 1.33c-2.349.364-8.632 2.655-9.5 8.79a.6.6 0 1 1-1.19-.168C1.188 3.092 8.132.544 10.725.141c5.627-.878 9.383 2.496 11.025 5.943z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "578oeen77ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.811.82a.601.601 0 1 1-.78.915 2.215 2.215 0 0 0-2.074-.44c-.76.212-1.368.762-1.587 1.432-.29.883-.2 1.858.236 2.607.426.73 1.162 1.218 2.127 1.412a.601.601 0 1 1-.236 1.179C1.84 7.593.99 6.663.567 5.94-.04 4.9-.168 3.558.227 2.353.568 1.306 1.49.457 2.63.136c1.138-.32 2.297-.07 3.181.685z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "978ccubxyah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05.202c.261.292.475.518.65.705.253.269.436.463.573.656a.6.6 0 1 1-.98.697 6.362 6.362 0 0 0-.469-.529 32.138 32.138 0 0 1-.671-.729.6.6 0 1 1 .897-.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39o8an6ftai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14.336c.173.348.47.619.758.69.199.048.39.003.587-.14a.6.6 0 1 1 .708.973c-.355.258-.742.39-1.139.39-.147 0-.296-.018-.445-.055C.972 2.036.393 1.54.062.867A.601.601 0 1 1 1.141.336z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w1dinvxtaaj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.147.348c.113.241.354.439.664.54.305.1.548.067.635.02a.602.602 0 0 1 .577 1.055c-.236.129-.524.194-.832.194a2.43 2.43 0 0 1-.756-.125C.809 1.825.307 1.396.055.854A.602.602 0 1 1 1.148.348z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "moq0hrppgak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.415.348c.115.245.663 1.506.235 2.214-.419.692-.887.823-1.335.823-.14 0-.278-.013-.412-.025-.1-.01-.21-.02-.331-.026a.603.603 0 0 1 .06-1.202c.14.007.266.019.383.03.447.04.447.04.606-.223.025-.125-.119-.702-.296-1.083a.601.601 0 1 1 1.09-.508z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6x5taop58al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.091.251c.517.724.803 1.125 2.169.758a.602.602 0 0 1 .312 1.162 4.615 4.615 0 0 1-1.186.177C1.228 2.348.658 1.713.112.95a.602.602 0 0 1 .98-.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "czkn83kc8am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.92.091c1.658 1.037 1.945 4.08 1.986 4.68a.601.601 0 0 1-.56.641.6.6 0 0 1-.64-.559C1.608 3.418 1.12 1.636.283 1.112A.601.601 0 1 1 .92.092z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oufv0374ban"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.103.27c1.53 2.32 2.002 5.413 1.56 6.947a.602.602 0 0 1-1.156-.332c.32-1.115.01-3.803-1.408-5.952A.602.602 0 0 1 1.103.27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am9s3w892ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.114.286c.977 1.586 1.1 4.937.261 7.17A.601.601 0 1 1 .25 7.036C.951 5.163.873 2.19.09.917A.601.601 0 1 1 1.114.286z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8f6yxqt9jap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.652.43c.485 1.626.272 4.232-.496 6.062a.6.6 0 1 1-1.109-.465C.697 4.476.901 2.119.5.774A.601.601 0 1 1 1.652.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2clc4ku2kaq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81.454c.306 1.219.195 2.998-.77 4.028a.601.601 0 1 1-.877-.823c.544-.581.751-1.832.48-2.912A.602.602 0 0 1 1.812.454z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31ztmr79dar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.35.001c.817.044 1.672 1.223 3.57 4.11.175.265.357.543.542.82l.279.417c.744 1.103 1.483 2.127 1.873 2.356a.602.602 0 0 1-.607 1.038c-.728-.426-1.653-1.784-3.092-3.97-.777-1.182-1.902-2.893-2.483-3.43-.5 1.371 1.527 4.67 3.77 7.325l.075.083.082.082c.051.05.102.102.151.154a.6.6 0 0 1-.74.932C6.064 9.51 5.47 8.821 4.899 8.154a15.41 15.41 0 0 0-.935-1.025 16.7 16.7 0 0 1-.817-.897c-.423-.486-1.263-1.45-1.68-1.655a.435.435 0 0 0-.01.075c-.074 1.465 3.586 5.552 4.63 6.417l.03.025a.602.602 0 0 1-.755.936l-.535-.437c-.738-.607-2.838-2.33-3.626-2.78.053.301.58.988.766 1.229.133.174.255.333.345.469.36.534 2.934 2.787 4.112 3.597.205.14.468.304.773.493 1.583.988 4.234 2.64 5.973 5.338a.6.6 0 1 1-1.01.651c-1.594-2.47-4.102-4.033-5.6-4.967-.323-.2-.6-.375-.817-.522-1.161-.8-3.918-3.158-4.43-3.92-.079-.118-.185-.256-.3-.406-.521-.678-1.169-1.521-.98-2.324.062-.26.239-.62.734-.86.192-.094.385-.126.75.037C.763 6.522.213 5.416.255 4.591c.025-.488.24-.88.626-1.13a.645.645 0 0 1 .11-.056c.552-.213 1.12.077 1.706.597C2.098 2.575 1.91 1.216 2.655.31A.842.842 0 0 1 3.35 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "33wne4mkcas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.656 8.576c.408-.308 1.502-.904 2.664-1.505l.539-.277.535-.271.765-.383c.406-.202.773-.382 1.065-.523.62.677 1.796 1.716 2.172 2.111.103.109-3.494 4.62-5.379 5.891-1.336.903-2.931 1.157-4.728-.248L0 0c4.975 2.27 5.948 6.35 6.656 8.576z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4lh5ibq70at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.852.054c4.696 2.144 6.007 5.828 6.746 8.194.497-.291 1.145-.64 1.81-.987l.445-.23a141.95 141.95 0 0 1 2.71-1.354.602.602 0 0 1 .705.135c.357.388.928.925 1.388 1.355.332.312.621.584.777.749a.625.625 0 0 1 .165.489c-.075.69-4.015 5.215-5.642 6.314-.83.56-1.68.84-2.53.84-.98 0-1.958-.371-2.906-1.112a.602.602 0 0 1 .741-.948c1.376 1.075 2.652 1.146 4.02.223 1.492-1.005 4.167-4.229 4.954-5.298-.12-.115-.256-.243-.402-.38-.377-.353-.792-.742-1.14-1.092-1.837.9-4.452 2.238-5.073 2.706a.603.603 0 0 1-.936-.298l-.14-.449C5.836 6.623 4.767 3.164.352 1.149a.602.602 0 1 1 .5-1.095z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tosxha3gkau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.943.235a.602.602 0 0 1-.11.843c-.7.538-1.254.95-1.717 1.296-1.9 1.416-2.244 1.671-5.061 4.907a.6.6 0 0 1-.848.058.6.6 0 0 1-.059-.848C3.05 3.158 3.454 2.857 5.397 1.409 5.857 1.066 6.406.657 7.1.124a.602.602 0 0 1 .843.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4fu60vcvoav"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.259 1.139c2.146 1.153 2.597 2.379 2.597 3.203 0 3.696-8.206 5.69-15.928 5.69C8.206 10.033 0 8.039 0 4.343c0-.786.412-1.959 2.376-3.079C5.201-.35 26.306-.447 29.26 1.14zM16.4 1.204l-.75.002c-5.753.03-11.454.404-12.678 1.102-1.141.65-1.769 1.373-1.769 2.034 0 2.123 6.047 4.488 14.725 4.488s14.725-2.365 14.725-4.488c0-.701-.697-1.463-1.964-2.143-1.134-.61-5.763-.934-10.805-.987l-.74-.006-.744-.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pw1evnm8kaw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.166.013c1.455-.116 5.54.536 9.411 1.556l.565.152c5.344 1.466 10.008 3.606 6.352 5.346l-2.537.97c-3.132.997-7.166 1.212-10.545 1.21-2.931 0-6.313.693-8.428-1.623C.687 6.205-.925 3.886.654 2.705 2.337 1.445 5.005.185 7.167.013z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g9ibmcmazax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.709.01c4.308.355 5.3 11.524 5.44 14.575.32 7.095.378 20.785.385 30.792l.001 1.759v3.226l-.001.494v.947l-.001.451-.001.857v1.161l-.001.352v.65L0 18.984C.087 15.76.253-.442 5.709.009z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ajcf00bxtay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36.011c5.065.419 5.878 12.691 5.99 15.147.197 4.356.295 11.139.343 18.053l.01 1.661c.025 4.152.033 8.286.034 11.905v3.428l-.002 2.976-.002 2.695a.602.602 0 0 1-1.203 0l.002-2.696.002-2.972v-3.426c-.004-10.122-.056-24.275-.385-31.57C10.934 10.493 9.637 1.49 6.26 1.21c-.569-.043-1.078.139-1.555.567-2.085 1.874-3.26 7.722-3.492 17.384l-.011.44A.603.603 0 0 1 0 19.57l.01-.438C.1 15.402.375 4.052 3.902.883 4.628.23 5.456-.062 6.36.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0cgyvjbp6az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.053.015C9.607.365 9.1 10.253 8.78 12.738L0 17.221C.51 14.38.541-.53 6.053.015z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap4tyqw29aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.714.018c.708.07 1.321.426 1.824 1.057 2.499 3.142 1.452 12.252 1.44 12.343a.602.602 0 0 1-1.193-.155c.346-2.68.528-9.28-1.189-11.439-.296-.372-.623-.57-1.001-.609-.602-.058-1.137.111-1.63.522-2.533 2.108-3.162 9.571-3.5 13.58-.098 1.158-.175 2.072-.272 2.613a.602.602 0 0 1-1.183-.212c.086-.485.162-1.375.256-2.502.377-4.478 1.01-11.974 3.93-14.404.742-.618 1.59-.887 2.518-.794z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hvbfe6mmzaB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.683 6.078c-.693 3.846-1.81 7.429-3.318 11.087-.623 1.515-1.348 3.92-2.2 6.101L0 11.076C.696 8.48 3.869 1.385 6.302.263c3.267-1.508 2.727 3.885 2.38 5.815z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5yeeex1pnaC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.052.374c1.61 1.244 1.038 5.221.826 6.41-.672 3.726-1.738 7.288-3.355 11.211-.307.745-.648 1.737-1.008 2.786a88.257 88.257 0 0 1-1.187 3.304.602.602 0 0 1-1.12-.436c.418-1.073.8-2.185 1.17-3.26.367-1.066.712-2.074 1.033-2.853 1.583-3.841 2.627-7.325 3.282-10.964.388-2.162.384-4.66-.376-5.245-.24-.187-.634-.162-1.16.082-2.06.95-5.192 7.505-5.974 10.424a.601.601 0 1 1-1.162-.312C.6 9.357 3.803 1.631 6.65.317 7.858-.241 8.623.04 9.053.374z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i0suc5thyaD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.595 3.313c3.32-7.198 5.965-1.235 5.782 4.35-.21 6.377-.747 15.499-3.016 24.223L.069 45.822C-.44 37.55 1.956 9.04 4.595 3.313z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j34omsv44aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.587.05c2.099.497 3.104 4.615 2.986 8.237-.205 6.232-.742 15.537-3.036 24.354a.602.602 0 0 1-1.165-.303c2.265-8.7 2.795-17.916 2.998-24.09.121-3.714-.987-6.773-2.06-7.026-.683-.167-1.648.939-2.575 2.946-2.548 5.53-4.998 33.68-4.47 42.22a.602.602 0 0 1-.564.638H.663a.6.6 0 0 1-.6-.564c-.478-7.758 1.822-36.813 4.58-42.797C5.898.945 7.225-.272 8.587.051z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d7llo2n8raF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.193.553c2.88-1.704 3.966.79 3.19 3.939-1.698 6.882-9.695 18.347-15.04 24.106L0 28.91C2.174 18.605 9.742 3.78 15.193.553z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1x87k7f66aG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.733.409c1.056.785 1.376 2.636.836 4.831-1.757 7.123-9.947 18.73-15.184 24.371a.603.603 0 0 1-.882-.819c5.149-5.544 13.19-16.914 14.897-23.84.411-1.664.255-3.101-.385-3.577-.514-.383-1.324-.049-1.913.3C11.096 4.638 3.432 19.012 1.19 29.638a.602.602 0 0 1-1.177-.247C2.138 19.315 9.697 4.069 15.489.64c1.636-.969 2.668-.66 3.244-.231z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "86w2xm1mbaH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.46 8.612.203.552a69.863 69.863 0 0 1 2.247 7.57l-.782 27.408c-3.202-6.998-6.335-16.66-8.84-24.595C.512 13.925-1.632 2.169 1.904.297c2.92-1.545 5.624 3.177 7.555 8.315z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pihch0y1aaI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.921.294c4.482 2.04 7.59 14.442 8.168 16.907a.603.603 0 0 1-1.172.274C10.682 12.206 7.716 2.887 4.423 1.39c-.572-.26-1.095-.247-1.644.045-2.858 1.512-1.415 11.92.675 18.535 2.784 8.819 5.778 17.894 8.814 24.527a.602.602 0 0 1-1.095.501c-3.061-6.693-6.07-15.81-8.866-24.666C1.162 16.711-2.205 2.71 2.217.37 3.095-.096 4.005-.122 4.92.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x1vj5j2w9aJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.835.005c6.52-.473 3.993 31.504 3.653 41.683l-3.74-.392c-.588-5.09-1.42-16.068-1.882-21.065C.358 14.739-1.592 1.459 2.836.005z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g5rrtre1vaK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39.785C8.551 3.872 8.715 16.39 8.24 29.627l-.038 1.02c-.026.68-.054 1.361-.083 2.043l-.044 1.023c-.03.682-.06 1.363-.092 2.042l-.048 1.018-.025.508c-.095 1.972-.178 3.69-.223 5.029a.602.602 0 0 1-.6.581h-.02a.603.603 0 0 1-.582-.621c.045-1.345.128-3.068.223-5.047.164-3.4.371-7.691.475-12.118l.02-.95c.197-9.838-.16-20.076-2.654-22.51-.315-.307-.63-.443-.999-.442C.152 2.475 1.302 13.44 1.857 18.728c.079.758.151 1.45.206 2.05.16 1.72.363 4.153.585 6.809l.14 1.664.094 1.124c.363 4.32.747 8.72 1.062 11.454a.602.602 0 0 1-.53.667.607.607 0 0 1-.666-.529c-.385-3.347-.87-9.155-1.299-14.28-.221-2.652-.424-5.08-.583-6.8-.055-.594-.127-1.281-.206-2.034l-.041-.394-.08-.786-.078-.783-.073-.78C-.328 8.328-.396 1.23 3.246.035a.59.59 0 0 1 .145-.028c.74-.056 1.415.208 1.998.778z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dq1f69yppaL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.196.507 3.373 14.32a.602.602 0 0 1-1.188.188L.007.695a.603.603 0 0 1 .5-.689.606.606 0 0 1 .689.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1u9mroc02aM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07.008c.835.077 1.706.694 2.026 1.435.218.505.16 1.032-.162 1.445-.55.706-1.712 1.565-2.481 2.133-.181.134-.333.246-.438.328a.6.6 0 0 1-.845-.102.601.601 0 0 1 .102-.844c.112-.088.273-.207.465-.349.673-.497 1.799-1.33 2.248-1.906.029-.037.068-.087.007-.229-.143-.33-.646-.678-1.033-.714-.492-.031-1.94.91-2.898 2.045a.601.601 0 0 1-.919-.775C.865 1.617 2.76-.13 4.07.008z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ihw6xyhgeaN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.836.1a.602.602 0 0 1 .168.835C3.651 7.485-.753 15.09 2.136 22.468c.998 2.547 2.775 4.336 4.754 4.784 1.029.233 3.919.238 4.77-.145a.602.602 0 0 1 .494 1.096c-.659.297-1.933.412-3.132.412-.97 0-1.891-.076-2.397-.19-2.369-.536-4.466-2.6-5.608-5.518C-2.083 14.99 2.48 7.07 7.002.269a.601.601 0 0 1 .834-.168z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5t5qvba4aO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.681.44a.602.602 0 0 1-.418.741c-1.214.34-1.5.438-2.873.909l-.223-.56L0 .953C1.367.483 1.691.372 2.94.023A.6.6 0 0 1 3.68.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2mpmlpf25aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.548.168 2.557 2.536c-.557.442-1.229 1.126-1.576 1.842-.228.468-1.788 6.277-2.514 6.126-.813-.17-1.52-7.36-.532-8.375C1.794.95 1.497 1.133 2.73 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mjh3xyqpqaQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.778.194a.603.603 0 0 1-.036.85c-.729.67-.903.86-1.218 1.206-.212.233-.482.531-1.005 1.068-.456.514-.384 5.237.183 6.97.496-1.02 1.213-3.319 1.481-4.177.193-.62.299-.955.37-1.136l.04-.091c.475-.98 1.377-1.76 1.743-2.05a.602.602 0 0 1 .747.942c-.626.498-1.153 1.108-1.408 1.634-.044.096-.196.586-.344 1.059-1.322 4.24-1.874 5.413-2.65 5.413a.935.935 0 0 1-.185-.02c-.502-.105-.731-.65-.89-1.17-.55-1.802-1.054-7.08.05-8.213.51-.523.772-.812.978-1.038.327-.36.525-.577 1.293-1.283a.605.605 0 0 1 .851.036z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wrv340xcwaR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13.312C2.04 1.976 3 3.27 4.016 4.64a.602.602 0 0 1-.967.717C2.054 4.014 1.025 2.626.074.89A.602.602 0 1 1 1.13.312z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w7iefar01aS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.708.417a.602.602 0 0 1-.388.757c-4 1.288-13.276 4.139-17.547 5.41A.602.602 0 0 1 .43 5.43C4.695 4.161 13.96 1.314 17.952.028a.601.601 0 0 1 .756.388z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91nbv9r1yaT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.927.027c.395.093.718.337.94.703.746 1.24.19 3.845-.085 4.908-.21.816-.484 1.719-.774 2.674-.554 1.828-1.127 3.717-1.341 5.262-.25 1.8-.017 4.062.227 6.46.052.492.102.989.15 1.484a.602.602 0 0 1-1.199.113c-.046-.492-.097-.984-.147-1.475-.253-2.47-.493-4.805-.223-6.747.228-1.639.815-3.574 1.382-5.446.286-.943.556-1.834.76-2.626.47-1.821.558-3.423.218-3.986-.06-.102-.116-.134-.167-.149.01.014-.117.068-.354.295C2.577 2.2 1.862 4.13 1.19 7.234A.603.603 0 0 1 .013 6.98C.76 3.541 1.544 1.523 2.484.627c.193-.186.788-.757 1.444-.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2te1qrn73aU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.304.001a.607.607 0 0 1 .636.566.602.602 0 0 1-.566.635c-.463.028-1.97.072-3.711.124-1.802.054-3.821.114-4.765.16l-.261.013H.601A.602.602 0 0 1 .566.298C1.36.251 3.626.183 5.626.124 7.288.074 8.858.028 9.304.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rrssjrqazaV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.831.002a.602.602 0 0 1 .558.643c-.33 4.637-1.086 18.407-1.186 22.438a.602.602 0 0 1-.601.586H.586A.601.601 0 0 1 0 23.052C.1 19.01.86 5.207 1.19.56A.6.6 0 0 1 1.83.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6752ywty3aW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.764.003c.33.033.572.328.539.659-.37 3.708-.656 10.524-.886 16.001-.08 1.907-.151 3.611-.215 4.895a.601.601 0 0 1-.6.572h-.03A.601.601 0 0 1 0 21.498c.063-1.283.135-2.983.215-4.886.23-5.493.515-12.328.89-16.071a.6.6 0 0 1 .658-.539z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tse872jzuaX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.624 0 11.101.427a.602.602 0 0 1-.022 1.203h-.024L.578 1.203A.601.601 0 0 1 0 .579C.012.247.257-.016.624.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "891aqnenxaY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.523 3.293a.6.6 0 1 1-1.116.446c-.765-1.913-5.499-2.67-8.169-2.518-.19 3.937.251 22.189.504 25.91 2.132-.362 3.246-.474 5.98-.63a.611.611 0 0 1 .635.567.602.602 0 0 1-.566.635c-2.936.167-3.966.282-6.48.724a.601.601 0 0 1-.696-.488C.45 27.018.261 21.346.137 15.387l-.019-.943C.051 10.983.006 7.505.001 4.876V3.85C.005 2.226.028 1.052.077.602c.03-.279.248-.5.528-.533 2.429-.287 8.726.236 9.918 3.224z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uumfo2ilnaZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36.106a.6.6 0 0 1-.029 1.203l-.03-.001c-1.695-.084-4.195-.15-5.664-.065a.6.6 0 1 1-.07-1.2C2.084-.048 4.636.02 6.36.105z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zgorztb9lba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.386 0a.602.602 0 0 1 .064 1.201c-.83.045-1.713.053-2.648.062-1.04.01-2.115.02-3.165.082H.601A.602.602 0 0 1 .566.144C1.646.08 2.736.071 3.791.06 4.712.051 5.582.043 6.386 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0xthv01xnbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.311.568a.602.602 0 0 1-.565.636c-.736.043-1.531.067-2.359.09-.89.028-1.817.055-2.75.11-.012.002-.023.002-.036.002A.601.601 0 0 1 .566.203a95.526 95.526 0 0 1 2.785-.11 79.38 79.38 0 0 0 2.324-.09c.301-.029.617.232.636.565z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqzu3yf0lbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.274.066c.33.032.573.325.543.656a.599.599 0 0 1-.656.542c-1.387-.13-2.957-.03-4.62.077l-.904.056H.601A.602.602 0 0 1 .566.197L1.464.14C3.177.031 4.794-.07 6.274.066z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xpzydcs65bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.908.037c.772.03 1.572.062 2.58.002a.6.6 0 1 1 .071 1.2c-.443.027-.847.037-1.224.037-.529 0-1.007-.019-1.476-.038-.726-.029-1.411-.056-2.222-.009a.601.601 0 1 1-.07-1.2c.868-.052 1.582-.024 2.34.008z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2sdxs7hg0be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.253.418a.608.608 0 0 1-.046.648.6.6 0 0 1-.682.21c-.2-.016-.724-.026-1.367-.028h-.502l-.526.003-.533.005c-.794.01-1.544.027-1.96.052A.62.62 0 0 1 .001.743.601.601 0 0 1 .566.107 55.254 55.254 0 0 1 3.408.001h.382c2.244.013 2.4.302 2.463.417z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3gd1d1h3nbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.157.093a.602.602 0 0 1-.033 1.202H5.09c-1.703-.097-2.857-.129-4.453-.036a.601.601 0 1 1-.07-1.2C2.22-.04 3.41-.006 5.156.093z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5j7mmm3iubg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.758.02c.966.26 1.73.6 2.468.928.468.209.91.405 1.377.568a.6.6 0 1 1-.396 1.136c-.514-.18-1-.396-1.47-.604-.696-.31-1.416-.63-2.291-.866A.601.601 0 1 1 .758.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zhjwdys3ebh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.768.023c1.704.491 3.198 1.02 3.998 1.416a.602.602 0 0 1-.534 1.078c-.727-.36-2.183-.873-3.796-1.337A.602.602 0 0 1 .768.023z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ihjybtyr6bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.713.011c.561.106 1.455.304 2.236.476.541.12 1.145.253 1.382.298a.62.62 0 0 1 .62.799c-.092.277-.157.407-.473.407-.298 0-.818-.115-1.789-.33-.768-.169-1.646-.363-2.199-.467A.602.602 0 0 1 .713.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "emrtf00olbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.749.018c.807.203 1.577.39 2.193.54 1.855.45 1.854.46 1.832.961a.607.607 0 0 1-.864.518c-.171-.049-.697-.176-1.252-.31a259.2 259.2 0 0 1-2.204-.543.602.602 0 0 1-.436-.73.605.605 0 0 1 .73-.436z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "va50y9ecobk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.674.004c.938.114 2.937.412 3.788.718a.601.601 0 0 1-.409 1.133C3.438 1.632 1.778 1.35.53 1.198A.6.6 0 1 1 .674.004z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4iitojnuzbl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.628 0c4.124.182 4.307.478 4.315.92v.063a.605.605 0 0 1-.578.601H4.34a.63.63 0 0 1-.15-.018c-.313-.048-2.45-.313-3.614-.363A.602.602 0 0 1 .628 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3v6xfuypubm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.742.11c.474.05.921.096 1.39.098a.602.602 0 0 1-.004 1.203c-.53-.002-1.029-.054-1.51-.104-.652-.068-1.27-.13-1.982-.09A.601.601 0 1 1 .566.015c.812-.049 1.506.024 2.176.093z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jx4olbhd2bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.154.02c.332.017.586.3.57.632a.623.623 0 0 1-.633.569c-.932-.049-1.913.013-2.86.073l-.594.037H.601A.602.602 0 0 1 .566.13l.588-.036c.983-.061 1.998-.126 3-.073z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lmsfl9um7bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.238.365a.602.602 0 0 1-.316.79c-.945.404-1.506.714-1.935 1.073A.598.598 0 0 1 .14 2.15a.6.6 0 0 1 .077-.847C.742.865 1.388.5 2.449.049a.6.6 0 0 1 .789.316z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lr2eqqn0sbp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.736.005c.33.037.567.335.53.665-.115 1.003-.058 6.396.048 12.007l.018.937c.108 5.466.255 10.92.33 12.527.318-.016.76-.058 1.064-.087.274-.027.536-.052.74-.066.35-.018.619.23.64.56a.6.6 0 0 1-.56.64 23.84 23.84 0 0 0-.705.063c-.638.061-1.071.098-1.382.098-.412 0-.606-.065-.77-.22a1.392 1.392 0 0 1-.016-.014L.66 27.1l-.015-.016-.014-.018-.013-.021c-.173-.3-.247-1.59-.473-12.55C.095 12.093.011 7.568.001 4.279V3.36C.002 1.998.022.952.07.534a.593.593 0 0 1 .665-.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "930l9ftdcbq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.203.566c.056.95.47 4.247.694 6.018l.074.59c.432 3.445.524 7.495.591 10.453.035 1.553.063 2.779.128 3.481a.602.602 0 0 1-1.198.111c-.068-.743-.096-1.989-.132-3.565-.067-2.931-.157-6.946-.583-10.33l-.073-.59C.464 4.824.06 1.628 0 .638A.601.601 0 0 1 .566.002a.6.6 0 0 1 .637.564z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "171126abobr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.935 12.488c.282 4.84.278 9.569.059 13.526-7.816-.049-13.825.161-19.847.002l-.024-.858c-.06-2.201-.117-4.49-.123-7.402v-1.172c.007-2.412.049-5.249.147-8.765L18.191 0c.735 3.95 1.497 8.26 1.744 12.488z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xvmpigj8lbs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.384.491c.752 4.04 1.505 8.336 1.753 12.562.268 4.594.289 9.422.059 13.595a.602.602 0 0 1-.6.568c-3.33-.02-6.288.006-9.148.03-1.886.017-3.718.033-5.516.033-1.759 0-3.486-.016-5.198-.06a.603.603 0 0 1-.587-.586l-.005-.166c-.066-2.399-.134-4.842-.141-8.032v-1.182c.006-2.432.047-5.295.146-8.85a.603.603 0 0 1 1.203.034c-.236 8.384-.144 12.905-.031 17.02l.015.572c3.261.075 6.59.045 10.103.015 2.698-.024 5.48-.05 8.587-.034.196-3.994.165-8.545-.088-12.886-.244-4.157-.99-8.412-1.734-12.412a.602.602 0 1 1 1.182-.22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ux7mfvfyubt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.021.17c2.257 2.195 4.54 4.313 6.957 6.556 3.568 3.31 7.258 6.734 11.21 10.734a.6.6 0 1 1-.854.846c-3.935-3.982-7.615-7.396-11.175-10.699C4.737 5.361 2.45 3.237.182 1.031a.6.6 0 1 1 .84-.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dle5mabdubu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.052.201c4.033 4.53 7.434 8.02 9.918 10.568.486.497.94.963 1.363 1.401.068-2.11.092-4.679.112-6.823.01-.984.017-1.874.028-2.582.006-.332.29-.562.611-.591.333.005.598.279.592.61-.01.707-.019 1.593-.028 2.574-.025 2.66-.055 5.972-.169 8.276a.602.602 0 0 1-1.036.386c-.675-.71-1.455-1.51-2.334-2.411C7.617 9.053 4.205 5.552.153 1.002a.602.602 0 1 1 .899-.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vd52kq001bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.079.003a.6.6 0 0 1 .55.648c-.74 9.056-2.341 15.713-5.188 21.583-1.353 2.79-3.96 4.382-6.895 4.382-.812 0-1.65-.121-2.49-.374C16.417 25.152 5.371 11.886.086 3.145a.6.6 0 1 1 1.03-.622c5.445 9.006 16.259 21.66 19.282 22.566 3.3.989 6.5-.37 7.959-3.38 2.78-5.73 4.345-12.254 5.072-21.156a.592.592 0 0 1 .649-.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68hbugwkdbw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.878.423a.602.602 0 0 1-.395.754L.782 6.716a.602.602 0 0 1-.36-1.149L18.125.03a.6.6 0 0 1 .753.394z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "su3zvv0tfbx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.05 0a.602.602 0 0 1 .003 1.203l-19.45.08A.602.602 0 0 1 .6.078L20.05 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ddy585li8by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.624 0c.332.003.6.274.597.606-.04 5.247-.09 11.745.79 17.194 1.033.128 3.951.194 6.856.227l.757.007c1.507.014 2.965.02 4.105.02h.543c.77 0 1.335-.003 1.583-.007a.632.632 0 0 1 .618.36.6.6 0 0 1-.112.65c-.078.085-.13.14-.449.173v.019a.526.526 0 0 1-.101-.01 19.81 19.81 0 0 1-1.368.034h-.606c-1.04-.004-2.54-.019-4.712-.04-7.03-.07-7.618-.28-7.84-.358a.601.601 0 0 1-.393-.465C-.076 12.775-.024 6.022.018.597A.6.6 0 0 1 .62 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2zm0lrrb9bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.542c.349 3.49.657 6.07.905 8.143.192 1.605.339 2.832.43 3.864 2.494.104 5.638.083 8.194.066.868-.006 1.671-.011 2.36-.011a.602.602 0 0 1 0 1.203c-.687 0-1.487.005-2.352.01-1.02.008-2.134.015-3.262.015-1.921 0-3.889-.021-5.528-.106a.602.602 0 0 1-.57-.556C1.297 12.056 1.136 10.7.91 8.828A391.044 391.044 0 0 1 .003.662.601.601 0 0 1 1.2.542z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w976htm9mbA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.702.846a28.338 28.338 0 0 1 1.97 3.318c.508 1.034 1.813 3.07 2.802 4.359-.096-1.283-.166-2.407.198-3.743.271-.995.852-1.134 1.178-1.136.943.008 1.75 1.326 1.938 2.062.11.435.204.773.29 1.082.167.597.31 1.112.481 1.999.737 3.804 2.085 6.599 3.102 7.945a.602.602 0 0 1-.961.725c-1.42-1.883-2.662-5.039-3.322-8.441a20.167 20.167 0 0 0-.404-1.711L9.92 7.11a46.895 46.895 0 0 1-.298-1.107c-.108-.427-.493-.948-.718-1.111a1.39 1.39 0 0 0-.071.204c-.322 1.183-.246 2.193-.15 3.472.037.48.076.99.099 1.556a.6.6 0 0 1-.915.538c-1.14-.696-3.685-4.768-4.274-5.965a27.233 27.233 0 0 0-1.881-3.169c-.195-.283-.314-.325-.315-.325a1.826 1.826 0 0 0-.183 1.025C1.51 4.84 3.09 7.243 4.254 8.823a.602.602 0 0 1-.97.713C2.04 7.845.348 5.262.019 2.366-.084 1.475.236.37 1.03.071c.337-.126 1.003-.196 1.671.774z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5wd3dzaewbB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.984.022 21.176 21.642a16.11 16.11 0 0 0-.812-.01h-.743c-5.994.006-28.404.152-51.214.277l-3.26.018c-15.75.084-31.329.156-41.462.161H9.65c-5.808-.002-9.378-.032-9.45-.101-.1-.914-.102-2.684-.103-4.696v-.764C.095 14.744.084 12.812 0 11.164l3.423-.495c3.041-.443 6.077-.891 9.1-1.341l2.263-.338C43.051 4.765 69.942.513 88.74 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "szt4d7rrabC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.326 0a.607.607 0 0 1 .618.585.602.602 0 0 1-.585.618c-17.164.468-41.231 4.082-66.711 7.908a3609.607 3609.607 0 0 1-21.42 3.172c.071 1.762.072 3.778.073 5.578v.363l.001.705c.003 1.265.013 2.363.058 3.123 1.048.037 3.801.055 7.768.059h3.033c9.248-.005 23.096-.066 37.329-.14l1.988-.01c9.617-.052 19.32-.108 27.816-.157 15.59-.091 23.228-.136 27-.141h1.344c1.857.003 2.244.024 2.37.06l.02.006a.194.194 0 0 1 .023.01l.013.007c.29.175.384.544.214.828a.595.595 0 0 1-.586.289 16.037 16.037 0 0 0-.367-.004l-.278-.001H107.804c-4.387.01-15.755.074-28.503.148-35.07.205-54.493.295-65.276.305h-1.007l-.324.001H11.26l-1.135-.001C.65 23.299.543 23.195.386 23.044a.599.599 0 0 1-.182-.368C.118 21.89.102 20.538.099 18.93l-.001-.705v-.362c0-1.976-.002-4.214-.098-6.065a.603.603 0 0 1 .516-.627c7.37-1.058 14.784-2.173 21.953-3.248C47.986 4.089 72.089.47 89.326 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "orxxg2gumbD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.165.158a.6.6 0 0 1 .036.85C4.639 2.71 3.45 3.78 2.583 4.562c-.738.664-1.226 1.102-1.465 1.502a.603.603 0 0 1-1.033-.62c.333-.554.874-1.04 1.693-1.777.85-.766 2.013-1.812 3.536-3.474a.603.603 0 0 1 .85-.036z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "udlvabp3nbE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.881.948C10.53.385 15.458-.323 18.257.162L17.06 2.367c-2.296 1.91-7.099 2.726-9.976 3.36C5.176 6.147-2.57 7.601.87 3.225 2.327 1.37 5.848 1.38 7.881.948z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eshjjw6r3bF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.159.375c5.113 12.526 27.446 22.19 35.47 23.925a.602.602 0 0 1-.253 1.176C28.174 23.703 5.326 13.768.045.83A.602.602 0 1 1 1.159.375z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n1y9s1qp4bG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23.049c.306.13.45.483.32.788-.963 2.272-2.03 4.355-3.062 6.37l-.35.685a.602.602 0 0 1-1.072-.547l.351-.687C1.44 4.662 2.495 2.598 3.442.368a.6.6 0 0 1 .789-.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j0pkx6bpmbH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.097.232a.602.602 0 0 1-.105.845C6.89 2.712 4.252 4.41.635 4.61l-.034.001A.601.601 0 0 1 .568 3.41c3.288-.183 5.73-1.762 7.684-3.283a.602.602 0 0 1 .845.105z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n0gmhp7b6bI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.187.463c1.242 5.215 2.214 12.449.93 29.917a.602.602 0 0 1-.599.557l-.045-.001a.602.602 0 0 1-.556-.644c1.272-17.305.319-24.43-.9-29.55a.601.601 0 1 1 1.17-.279z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1l657e0rgbJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.016.166c.273.26 1.062 1.191 1.415 2.369a.602.602 0 0 1-1.153.345C1.025 2.037.423 1.262.188 1.038a.6.6 0 1 1 .828-.872z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jkb6c6wghbK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.388 0a.612.612 0 0 1 .622.58c.047 1.312-.445 3.117-1.476 4.028a2.407 2.407 0 0 1-2.028.597.601.601 0 1 1 .191-1.187c.39.062.733-.038 1.04-.311.717-.633 1.107-2.065 1.07-3.085A.602.602 0 0 1 3.388 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yo331zhgbbL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.537c.052.484.459 1.016 1.036 1.353.677.397 1.457.456 2.139.164a.602.602 0 0 1 .474 1.105c-.44.189-.903.282-1.37.282a3.659 3.659 0 0 1-1.85-.513C.72 2.398.097 1.531.004.667a.601.601 0 1 1 1.195-.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5m6n7jl91bM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.546c.44 4.732.98 10.213 1.376 13.962a.602.602 0 1 1-1.196.127C.984 10.88.443 5.395.003.657A.601.601 0 1 1 1.2.547z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vn1j7jneebN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91.131c.26.206.302.585.096.845C9.052 2.18 7.17 3.014 5.212 3.103a7.894 7.894 0 0 1-.363.009c-1.855 0-3.507-.665-4.682-1.893a.602.602 0 0 1 .87-.832c1.006 1.052 2.471 1.59 4.12 1.514 1.6-.074 3.17-.745 3.907-1.674a.601.601 0 0 1 .845-.096z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "osx1p34yrbO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.738 0c.332 0 .601.27.601.602 0 .624-.141 3.492-.353 6.47l-.052.716c-.24 3.22-.555 6.37-.855 6.762a.603.603 0 0 1-.844.113.604.604 0 0 1-.16-.77C.395 12.914 1.136 3.13 1.136.603c0-.333.27-.602.602-.602z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pnf4kio9rbP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35 0c3.62 0 6.349 1.336 6.349 3.108s-2.73 3.108-6.35 3.108C2.73 6.216 0 4.88 0 3.108S2.73 0 6.35 0zm0 1.203c-3.19 0-5.147 1.11-5.147 1.905 0 .795 1.958 1.905 5.147 1.905 3.188 0 5.146-1.11 5.146-1.905 0-.796-1.958-1.905-5.146-1.905z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "97cw7m3fqbQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0a.602.602 0 0 1 0 1.204h-3.718C30.908 1.21 9.99 1.343 1.717 3.819c.6.57 1.198 1.075 1.823 1.601.928.781 1.887 1.59 2.883 2.658a.602.602 0 0 1-.879.821c-.947-1.015-1.879-1.8-2.78-2.56-.846-.714-1.723-1.452-2.598-2.37a.6.6 0 0 1 .228-.98C7.954.217 28.64.015 41.774.001H46.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heg5eoamibR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35.708a.602.602 0 0 1-.669 1c-.72-.48-2.108-.644-3.229-.377-.65.154-1.134.436-1.328.777A.603.603 0 0 1 .08 1.512C.45.864 1.174.397 2.176.16 3.633-.185 5.348.04 6.349.708z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ge3h7zw3pbS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.364 1.345a.602.602 0 0 1-1.031.62c-.459-.762-3.768-1.104-5.5-.363-.576.247-.639.47-.63.593.514.709 2.603.683 4.293.67.286-.004.569-.007.844-.007a.602.602 0 0 1 0 1.203c-.271 0-.55.003-.831.006-.294.003-.59.006-.884.006-1.97 0-3.836-.14-4.514-1.359a.606.606 0 0 1-.055-.134C-.055 2.168-.153 1.142 1.361.496c1.896-.81 6.072-.695 7.003.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zmml1iovpbT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.602 0c.332 0 .601.269.601.602 0 .915.068 1.598.202 2.514.307.196.571.423.867.675.335.287.75.643 1.374 1.08a.6.6 0 1 1-.69.985c-.671-.47-1.112-.847-1.467-1.15-.35-.3-.604-.518-.917-.684a.6.6 0 0 1-.315-.442C.091 2.48 0 1.68 0 .602 0 .269.27 0 .602 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fca9vbh12bU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.116 0c12.92 0 24.86 3.548 29.709 8.829 1.7 1.852 2.475 3.824 2.3 5.86-.72 8.452-14.182 14.585-32.01 14.585-17.204 0-31.605-6.55-32.102-14.598-.128-2.06.698-4.05 2.45-5.915C7.391 3.521 19.307 0 32.116 0zm0 1.203c-12.498 0-24.062 3.369-28.776 8.382-1.517 1.614-2.232 3.301-2.126 5.017.449 7.302 14.6 13.47 30.902 13.47 16.908 0 30.155-5.798 30.811-13.485.145-1.687-.525-3.35-1.989-4.945-4.635-5.047-16.218-8.439-28.822-8.439z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r21cfv6fobV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.834.018 33.82 1.002c2.593 1.154 2.987 5.1 3.978 7.43 1.222 2.872 2.53 4.284 2.188 7.408-.172 1.575-1.26 5.936-2.388 7.218-1.763 2.004-6.205.833-8.747 1.252-10.231 1.688-20.148 1.643-30.433 1.555-5.488-.047-10.312.246-15.52-.991-2.018-.48-4.029 1.164-5.374.222-.822-.576-1.37-3.26-1.596-4.644C.252 17.334-.635 12.294.71 9.286 4.157 1.564 17.805-.203 24.834.018z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fnb4ctum2bW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.19.478 3.514 16.574a.6.6 0 1 1-1.176.249L.013.727A.6.6 0 1 1 1.19.478z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hq8xsx9bubX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.471.008c.326.058.545.37.487.698L1.193 16.207a.601.601 0 1 1-1.183-.212L2.773.495a.605.605 0 0 1 .698-.487z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4rg7a5ndrbY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.92 0v29.007H0V0h73.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q5t8gb1pmbZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.96 0c20.726 0 36.96 6.37 36.96 14.504 0 8.133-16.234 14.503-36.96 14.503C16.236 29.007 0 22.637 0 14.504S16.235 0 36.96 0zm0 1.203c-19.382 0-35.757 6.091-35.757 13.301s16.375 13.3 35.758 13.3c19.382 0 35.757-6.09 35.757-13.3 0-7.21-16.375-13.301-35.757-13.301z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m24utc98ica"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.359 0c20.08 0 36.359 6.225 36.359 13.902S56.44 27.804 36.358 27.804C16.279 27.804 0 21.58 0 13.902S16.278 0 36.359 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vq907r2gxcb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.165 4.111c3.224 3.633 9.653 4.104 14.01 5.235 5.944 1.544 12.363 2.528 18.502 2.919 3.474.22 6.785.103 9.631-1.879 2.415-1.681 4.645-4.246 7.185-5.65.95-.525 5.227-.998 5.348.303l.668.401c.796 1.69 2.54 4.593 2.54 6.55 0 1.682-1.89 2.003-3.309 2.974-1.653 1.131-4.73 2.758-6.65 3.375-2.065.663-3.06.593-5.147 1.033-8.365 1.765-19.374 3.087-27.804 1.503-2.075-.39-2.88-.434-4.938-.738-2.09-.308-4.195-.713-6.29-1.055-2.129-.349-3.917-.907-5.848-1.912-1.658-.862-4.182-1.419-4.839-3.182-.357-.96-.255-2.164-.411-3.2C.645 9.67.26 8.568.148 7.444c-.182-1.85-.367-4.94.568-6.52 1.717-2.9 6.236 1.819 7.45 3.186z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x56i82956cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.182 3.226c2.807 4.01 4.279 7.752 5.384 12.386L0 .018c1.188-.192 5.77 1.19 7.182 3.208z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6803v0ayfcd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.276 3.484c2.665 3.806 4.252 7.455 5.476 12.59a.6.6 0 1 1-1.17.28c-1.187-4.978-2.72-8.508-5.29-12.181C5.985 2.308 1.595 1.067.697 1.214A.602.602 0 0 1 .506.026c1.502-.246 6.24 1.27 7.77 3.458z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ywxeyfeoce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.96.035.462 16.407c-.281-.628-.813-1.619-1.413-2.812l-.182-.364C.44 8.46-2.71.829 4.22 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "el74r1okzcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.424.53a.603.603 0 0 1-.526.668c-1.644.197-2.708.79-3.254 1.815-1.585 2.984 1.47 8.933 3.111 12.13.348.676.637 1.242.822 1.653a.603.603 0 0 1-1.1.493 37.298 37.298 0 0 0-.792-1.596C1.82 12.063-1.3 5.986.582 2.45 1.315 1.069 2.72.247 4.755.003a.603.603 0 0 1 .67.526z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1ly36zhucg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.937.04 55.965 6.354c2.018.535 4.954 7.625 4.874 9.235-.16 3.187-2.468 3.902-5.16 4.467-2.163.453-10.04.693-17.925.82l-1.575.024c-6.288.09-12.336.11-15.22.113-6.983.007-16.275.751-19.706-5.765C2.393 11.874-3.65 1.086 3.164 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3rp1roebgch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.358.508a.6.6 0 0 1-.498.688c-1.146.184-1.899.663-2.3 1.47-1.505 3.018 2.016 9.65 3.519 12.484l.244.461c2.8 5.318 9.771 5.515 16.196 5.466l.686-.006c.114 0 .228-.002.341-.003.664-.006 1.316-.013 1.948-.014h.927c5.695-.012 29.687-.11 33.67-.945 2.656-.557 4.547-1.163 4.684-3.907.079-1.591-2.89-8.217-4.427-8.625a.6.6 0 1 1 .309-1.162c2.455.65 5.406 8.115 5.32 9.847-.179 3.586-2.77 4.423-5.638 5.025-4.19.878-28.534.963-34.431.97h-.412c-.629.001-1.277.008-1.938.014-.708.007-1.436.015-2.173.015-6.222 0-13.183-.525-16.127-6.114l-.242-.458C2.291 12.464-1.297 5.7.483 2.129 1.063.967 2.134.253 3.67.009a.596.596 0 0 1 .688.499z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trzdviuycci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.014 4.896C-.19 2.289 1.848-.361 6.46.04l50.446 8.866c2.875 5.213 3.435 6.269 3.49 8.421.056 2.1-1.011 4.86-4.089 5.012-1.939.095-10.42.358-19.286.593l-1.7.045c-7.756.201-15.504.372-19.158.383h-.505c-.554 0-.982-.006-1.266-.017-3.698-.147-6.326-.31-7.85-3.767C5.355 16.883.427 8.104.015 4.896z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w0hl9bf2rcj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.111.044a.601.601 0 1 1-.105 1.198c-2.058-.183-3.697.27-4.734 1.298-.77.764-1.147 1.797-1.06 2.911.282 2.183 2.99 7.518 4.783 11.047.73 1.434 1.36 2.674 1.697 3.438 1.335 3.032 3.43 3.254 7.321 3.409 2.024.08 11.155-.113 20.413-.353l1.7-.045 1.13-.03c8.648-.232 16.78-.487 18.62-.577 2.864-.14 3.558-2.828 3.517-4.395-.051-1.991-.532-2.916-3.416-8.146a.601.601 0 1 1 1.053-.581c2.832 5.135 3.505 6.355 3.566 8.696.068 2.597-1.362 5.466-4.661 5.628-3.66.179-32.19 1.006-40.262 1.022h-.24a41.02 41.02 0 0 1-1.466-.018c-3.583-.142-6.675-.265-8.377-4.124-.324-.734-.946-1.96-1.667-3.379a292.055 292.055 0 0 1-1.685-3.354l-.38-.78C1.473 10.05.223 7.188.016 5.576-.1 4.095.413 2.689 1.424 1.687 2.328.79 4.042-.225 7.11.044z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zhexe56egck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.964 3.51C14.607.68 19.703-.642 26.497.302l45.435 6.511c.18.035.36.07.538.107l.534.111c5.403 1.162 9.959 3.162 8.364 8.652l-7.182 14.772c-2.345 5.059-3.726 5.013-9.224 4.41L7.79 26.158C3.874 25.51-4.029 23.94 2.487 15.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6arvit53acl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.177.302 45.44 6.511c3.783.732 7.846 1.84 9.505 4.557.853 1.396.995 3.104.422 5.076a.65.65 0 0 1-.036.095l-7.182 14.772c-1.849 3.988-3.215 5.02-6.207 5.02-1 0-2.182-.116-3.623-.274L8.297 27.347c-2.21-.366-6.792-1.125-8.005-4.183-.778-1.965 0-4.5 2.316-7.533l.007-.01 9.478-11.89C15.005.61 20.49-.628 27.177.3zM13.002 4.516 3.56 16.366c-2.038 2.673-2.762 4.81-2.15 6.354.963 2.427 5.092 3.111 7.077 3.44l57.165 8.706c5.274.578 6.377.699 8.587-4.07l7.164-14.734c.466-1.635.365-2.965-.307-4.065-1.416-2.316-5.182-3.321-8.68-3.998L27.01 1.493c-6.29-.871-11.398.227-14.008 3.023z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58lsojxnvcm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2.544 2.166 22.79a.602.602 0 0 1-1.199.115L.003.659A.602.602 0 0 1 .545.001.607.607 0 0 1 1.2.544z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kudpry8o0cn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.416 8.03c-1.481 3.998-3.042 2.217-4.282-.207l-.145-.288-.141-.292-.138-.294C.937 5.28.328 3.592 0 3.41L1.404 0C4.622.458 7.57 4.918 6.416 8.03z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nv1xq0lwvco"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.192.022 7.282 4.59c-1.062 6.227-8.723 13.607-14.186 16.285-1.532.75-4.347 3.643-5.46 1.792-.643-1.07-.92-5.696-.801-6.917C.554 10.292 7.189.382 13.457 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "io0p1yjxkcp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.995.005a.6.6 0 0 1 .508.683L1.197 23.174A.602.602 0 0 1 .007 23L3.313.513a.604.604 0 0 1 .682-.508z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nc75ndp5icq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.854.003a.6.6 0 0 1 .55.649L1.2 15.289a.601.601 0 1 1-1.198-.1L1.205.552a.593.593 0 0 1 .649-.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tryuikk8ncr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.98 3.73C16.789.722 22.202-.682 29.42.32l47.13 6.817c6.216 1.203 11.83 3.208 10.026 9.424l-8.633 17.043c-2.005 3.409-4.411 4.211-9.224 3.61L9.57 27.79c-6.416-1.003-13.634-3.008-6.817-11.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cxfy6qebdcs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.108.32 47.134 6.818c4.01.776 8.316 1.95 10.072 4.824.9 1.474 1.05 3.279.446 5.364a.69.69 0 0 1-.042.104l-8.633 17.043c-1.706 2.901-3.728 4.116-7.218 4.116-.792 0-1.659-.062-2.616-.182L10.08 28.98c-4.2-.655-8.651-1.729-9.8-4.715-.784-2.035.07-4.55 2.61-7.686.005-.007.01-.014.017-.02L14.137 3.925c3.06-3.28 8.88-4.59 15.971-3.606zM15.026 4.736l-11.21 12.61C1.61 20.077.798 22.26 1.404 23.834c.936 2.427 5.229 3.39 8.865 3.959l59.152 9.424c4.69.582 6.786-.22 8.61-3.32l8.59-16.96c.496-1.745.387-3.169-.333-4.347-1.511-2.473-5.522-3.544-9.245-4.264L29.939 1.512c-6.695-.928-12.133.245-14.913 3.224z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av65qmty9ct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32 3.612c0 .902-1.035 2.486-1.816 4.21-1.905 4.211-3.457 6.888-4.511 8.923C5.599 19.433 4.31 21.701.949 21.49c-1.6-.1-.877-.52-.015-1.043l.174-.105c.319-.197.637-.404.847-.613 1.08-1.075 1.757-2.35 2.612-3.59 1.66-2.407 2.696-5.296 3.93-7.92 1.192-2.539 2.392-5.199 3.609-7.714h-.1c1.13-1.987 1.314 2.5 1.314 3.108z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pla8e7ugccu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.134 3.027c1.013 1.419 1.811 6.68 1.577 8.32-.177 1.24-3.085 4.98-8.746 11.897-1.432 1.749-2.669 3.26-2.978 3.725a.602.602 0 0 1-1.002-.667c.343-.515 1.478-1.9 3.049-3.821 1.02-1.246 2.455-3 3.856-4.762l.419-.528c2.154-2.726 4.117-5.351 4.212-6.014.214-1.51-.592-6.368-1.365-7.45C36.077 2.654 20.283.14 17.026 1.523 13.74 2.919 2.462 17.626 1.173 21.576a.602.602 0 0 1-1.144-.372C1.405 16.99 12.997 1.926 16.558.416c3.11-1.32 20.251.752 21.577 2.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3sbc8d2qvcv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.951.113c1.36.972 1.849 3.183 1.451 6.574a.602.602 0 0 1-1.195-.14c.338-2.881.008-4.768-.955-5.456a.601.601 0 1 1 .7-.978z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3d4w0fryncw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.392 1.403C22.562-.307 25.233-.093 28.75.2c3.208.268 9.424.833 11.763 2.272 1.737 1.07 2.105 6.768.133 8.69l-15.154 19.05-1.183 2.907s-4.53-.643-9.223-1.337l-1.113-.166c-3.829-.57-7.538-1.145-8.757-1.403-2.832-.6-3.455-.982-3.455-.982-.522-.598-2.034-3.782-1.718-5.597.238-1.366 4.451-6.64 8.929-11.72l.598-.675c4.194-4.718 8.474-9.108 9.822-9.836z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vavdquf09cx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4.203c4.414.368 9.77.97 12.028 2.359 1.234.76 1.59 2.843 1.684 3.704.21 1.881-.044 4.562-1.446 5.928a.601.601 0 1 1-.84-.861c.87-.849 1.319-2.877 1.09-4.933-.152-1.385-.592-2.49-1.119-2.813C38.494 2.17 31.814 1.61 29.3 1.4c-3.479-.29-5.993-.5-9.022 1.134-1.426.769-5.739 5.256-9.9 9.982l-.594.677C5.445 18.16 1.43 23.209 1.234 24.339c-.26 1.504 1.024 4.334 1.515 5.017.232.102 1.052.417 3.191.871 2.512.532 15.91 2.45 18.588 2.832l1.006-2.472a.6.6 0 1 1 1.115.454l-1.184 2.907a.602.602 0 0 1-.641.368c-.353-.05-4.919-.698-9.551-1.385l-.794-.118c-3.833-.571-7.549-1.147-8.788-1.41-2.326-.493-3.224-.847-3.528-.994l-.061-.031a.596.596 0 0 1-.195-.15C1.282 29.513-.3 26.142.05 24.134c.251-1.446 4.257-6.517 8.627-11.507l.598-.68c4.396-4.974 9.003-9.7 10.431-10.47C23.05-.327 25.852-.092 29.4.203z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09scnvtjacy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.431.083 53.203 6.95c.286.123 3.78 5.4 4.278 7.887.802 4.01-.115 6.18-1.872 6.283-1.27.075-12.97.415-24.376.574l-1.34.018c-2.897.037-5.748.06-8.375.064h-1.196c-6.286-.007-11.048-.144-11.638-.522-1.33-.852-2.599-3.201-3.44-4.578a67.36 67.36 0 0 1-3.073-5.585C1.039 8.76-1.763 1.438 1.606 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kfhwyiq4scz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.762.365a.6.6 0 0 1-.317.79c-.473.201-.801.563-1.004 1.104-.822 2.201.67 6.69 1.873 9.172a66.098 66.098 0 0 0 3.047 5.534l.37.616c.782 1.312 1.852 3.11 2.88 3.768.69.316 5.088.433 10.935.44h1.15c3.498-.005 7.435-.045 11.368-.104l1.31-.02c10.255-.165 20.15-.446 21.803-.543.408-.024.73-.198.988-.53.675-.874.794-2.709.33-5.035-.444-2.216-3.547-6.99-4.044-7.519A.601.601 0 0 1 54.045 7c.657.284 4.146 5.907 4.629 8.32.548 2.747.357 4.823-.557 6.006a2.492 2.492 0 0 1-1.87.997c-.202.011-10.128.331-20.84.522l-.92.016-1.385.023-1.386.021c-3.233.047-6.444.078-9.393.08h-.42c-6.862 0-12.213-.156-12.94-.622-1.27-.813-2.423-2.75-3.266-4.166l-.363-.606a67.194 67.194 0 0 1-3.102-5.635C2.101 11.685-.972 5.28.314 1.839.634.983 1.192.381 1.972.05c.306-.13.66.011.79.316z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5vis4r9oscA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.793.187c3.034.25 7.831.675 10.045 2.02 1.642 1 1.989 6.328.125 8.126 0 0-2.935 4.362-6.209 8.814l-.47.636c-3.22 4.344-6.647 8.58-7.863 8.732-4.278.535-15.033-1.035-19.316-2.54C.4 25.727-.016 20.96 0 20.203c.063-2.564 13.24-17.45 15.942-18.89 2.998-1.6 5.524-1.4 8.85-1.126z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5697dl10gcB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.443.192c3.832.316 8.104.766 10.308 2.106 1.184.721 1.522 2.692 1.612 3.507.192 1.742-.044 4.219-1.335 5.518C24.76 28.067 21.75 29.635 21.096 29.716c-.602.075-1.33.11-2.146.11-5.1 0-13.693-1.36-17.444-2.68C.172 26.678-.002 20.85 0 20.794.073 17.806 13.575 2.817 16.26 1.385c3.166-1.69 5.82-1.473 9.183-1.193zm-8.617 2.255c-1.47.783-5.2 4.686-8.646 8.715l-.556.654c-3.41 4.034-6.398 8.033-6.42 9.005-.023.93.396 4.574.798 5.224 4.214 1.448 14.822 2.994 18.945 2.477 1.205-.156 6.387-6.785 11.505-14.111l.48-.689.477-.692.714-1.04c.316-.464.63-.927.941-1.39a.632.632 0 0 1 .082-.096c.812-.784 1.232-2.66 1.02-4.567-.161-1.465-.64-2.367-1.041-2.612-2.144-1.304-7.112-1.714-9.78-1.935-3.288-.27-5.664-.466-8.52 1.057z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kfzycoqfzcC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.621 1.672c.894.167 1.83.34 2.776.53l.473.097c.554.114 1.11.234 1.66.363l.472.112C52.036 4.24 57.36 6.77 53.86 13.1l-.136.27-.102.202a725.785 725.785 0 0 1-3.776 7.384l-.334.642-.168.321-.336.643c-1.568 2.992-3.123 5.87-3.98 7.214L0 22.936C4.23 16.132 10.155 9.198 15.46 3.142 19.677-1.67 32.057.068 40.622 1.672z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vd23nrejrcD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.335 1.668.295.056c5.458 1.02 12.252 2.292 14.081 6.172.806 1.71.563 3.758-.723 6.084a86.1 86.1 0 0 1-.072.145l-.088.175c-1.05 2.086-6.69 13.25-8.69 16.387a.602.602 0 0 1-1.016-.646c2.132-3.344 8.736-16.49 8.803-16.623 1.114-2.017 1.34-3.648.698-5.009-1.566-3.324-8.025-4.532-13.215-5.503l-.295-.055c-8.66-1.623-20.631-3.254-24.597 1.275-5.24 5.98-11.185 12.93-15.403 19.715a.6.6 0 1 1-1.022-.636C4.358 16.344 10.339 9.35 15.61 3.333c4.372-4.992 16.775-3.34 25.724-1.665z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6jckowm9kcE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.235 1.37c5.183.511 18.045 3.434 13.434 11.545 0 0-6.42 16.636-11.834 16.636L0 22.999C.266 19.174 9.319 8.796 14.703 2.82 18.979-1.928 32.214.58 40.235 1.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5101xtsvycF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.676.345.833.082c1.525.155 3.033.335 4.478.507 1.39.165 2.707.323 3.908.441C45.208 1.8 53.086 3.641 55.26 7.84c.922 1.78.772 3.777-.444 5.936-.747 1.93-6.758 16.98-12.38 16.98a.602.602 0 0 1 0-1.203c4.102 0 9.53-11.73 11.274-16.251a.52.52 0 0 1 .038-.08c1.037-1.824 1.182-3.403.444-4.829-1.94-3.749-9.623-5.447-13.414-5.821-1.21-.119-2.536-.277-3.933-.443-7.457-.89-17.669-2.104-21.092 1.698C6.28 14.337 1.386 21.005 1.2 23.645a.602.602 0 0 1-1.2-.084c.209-2.996 4.93-9.523 14.856-20.54C17.895-.348 24.865-.301 31.676.346z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y971710zicG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.742.346c1.001.236 4.025-.209 4.692 1.816.45 1.364-5.23 11.768-8.329 12.003l-.268.017c-3 .184-5.024-.017-7.937-.528-2.885-.507-3.653-1.603-2.144-4.16C2.173 7.09 4.4 3.606 6.553 1.82 8.816-.057 11.779-.353 14.743.346z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zrgnctwmvcH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.484.366c.181.043.515.06.868.08 1.353.071 3.617.19 4.257 2.134.437 1.324-2.144 5.835-3.464 7.812-1.464 2.195-3.589 4.841-5.391 4.978a.697.697 0 0 1-.142-.006.572.572 0 0 1-.135.025 34.22 34.22 0 0 1-2.075.067c-2.095 0-3.844-.226-6.002-.604-1.81-.318-2.8-.856-3.209-1.744-.391-.847-.184-1.9.65-3.314 2.23-3.781 4.226-6.416 5.932-7.83C9.015.103 12.028-.45 15.484.365zm-2.975.841c-1.645 0-3.43.406-4.968 1.683-1.599 1.326-3.503 3.854-5.664 7.516-.598 1.014-.798 1.754-.594 2.199.218.472 1 .83 2.325 1.062 2.8.49 4.775.709 7.796.52a.57.57 0 0 1 .133.007.592.592 0 0 1 .126-.024c.336-.024 1.312-.323 3.09-2.535 2.66-3.308 4.818-7.926 4.708-8.703-.348-1.049-1.7-1.207-3.172-1.285-.426-.023-.795-.042-1.082-.11a11.87 11.87 0 0 0-2.698-.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ioqxvrsd5cI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.574.124c.263.202.314.58.111.844-.835 1.093-3.623 4.842-6.5 8.727l-.597.805a2699.649 2699.649 0 0 0-5.85 7.928l-.32.434-.491.675c-1.778 2.446-2.863 3.723-6.231 3.723-1.06 0-4.542-.584-8.07-1.22l-.706-.127c-1.41-.256-2.802-.515-4.023-.742-1.533-.284-2.774-.514-3.394-.618A.601.601 0 1 1 .7 19.366c.624.104 1.873.336 3.415.623 1.23.228 2.707.502 4.213.775l.696.125.348.063.694.123c2.994.53 5.776.981 6.625.981 2.776 0 3.519-.829 5.26-3.226l.494-.675.319-.435C25.835 13.536 34.17 2.276 35.73.236a.602.602 0 0 1 .844-.112z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f5voyasucJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.742.346c1.001.237 4.025-.209 4.692 1.816.451 1.364-5.23 11.768-8.329 12.004l-.268.017c-3 .184-5.024-.018-7.937-.529-2.885-.506-3.653-1.603-2.144-4.16C2.173 7.093 4.4 3.607 6.553 1.823 8.816-.057 11.78-.353 14.743.346z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iep2wfacqcK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.484.366c.182.043.516.06.869.08 1.353.071 3.616.19 4.256 2.134.437 1.319-2.136 5.82-3.45 7.793-1.47 2.204-3.599 4.86-5.405 4.998a.64.64 0 0 1-.142-.007.58.58 0 0 1-.135.025c-.738.045-1.422.067-2.073.067-2.094 0-3.844-.225-6.005-.604C1.59 14.534.6 13.997.19 13.109c-.39-.848-.183-1.9.65-3.314 2.232-3.783 4.228-6.418 5.932-7.83C9.014.104 12.026-.45 15.484.365zm-2.974.84c-1.645 0-3.43.407-4.97 1.684-1.597 1.325-3.502 3.853-5.663 7.516-.599 1.015-.799 1.754-.594 2.2.218.472 1 .829 2.324 1.061 2.803.491 4.778.709 7.797.52.045-.003.09 0 .133.007a.592.592 0 0 1 .126-.023c.337-.026 1.313-.324 3.096-2.542 2.658-3.309 4.811-7.921 4.702-8.697-.348-1.048-1.699-1.208-3.171-1.285-.427-.023-.797-.042-1.082-.11a11.874 11.874 0 0 0-2.698-.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6f2iws4edcL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.318.742C8.804-.712 16.06.25 17.504 1.253c1.786 1.243-4.616 12.244-7.486 12.478C8.375 13.865.73 12.645.084 11.86-.773 10.82 5.162 2.343 7.451.724z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r1d2a1foscM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.45 1.343c.901.628.496 2.133.362 2.627-.883 3.283-5.4 10.72-8.143 10.944a3.34 3.34 0 0 1-.274.009c-2.01 0-9.32-1.059-10.174-2.098-.187-.227-.256-.54-.204-.927C.312 9.688 5.036 3.04 7.37 1.076a.61.61 0 0 1 .127-.18C9.231-.8 16.855.235 18.45 1.342zm-9.862.239a.607.607 0 0 1-.188.216C6.09 3.431 1.205 10.733 1.2 12.096c.914.575 7.636 1.758 9.37 1.62 1.472-.121 4.912-4.63 6.574-8.617.797-1.91.707-2.661.613-2.774-1.263-.875-7.493-1.622-9.169-.743z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lfbnyhvd9cN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.486.357c1.63.59 2.53 1.422 2.977 3.126.149.564.449 2.474.114 3.811L0 5.19C.537 4.33 2.258.898 3.357.358c1.106-.544 3.014-.406 4.13-.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "odus6e0slcO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.293.391c1.904.69 2.876 1.715 3.354 3.54.123.471.505 2.55.115 4.11a.602.602 0 0 1-1.167-.293c.301-1.205.024-2.996-.112-3.513-.374-1.426-1.079-2.162-2.6-2.713-1.032-.374-2.748-.473-3.659-.025-.704.347-2.052 2.747-2.628 3.773-.202.36-.37.656-.485.839a.601.601 0 1 1-1.02-.638C.2 5.3.357 5.02.548 4.68 1.657 2.704 2.734.89 3.693.419c1.242-.612 3.314-.494 4.6-.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "my84u2dszcP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37.008c1.62.084 3.01.811 4.36 1.692 2.172 1.419 1.236 4.714 1.152 5.548L0 7.998c.602-2.38 2.495-8.24 7.37-7.99z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kfpax6wv8cQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.002.01c1.836.094 3.385.957 4.659 1.79 2.141 1.397 1.732 4.236 1.508 5.568l-.02.124c-.03.174-.056.316-.065.419a.602.602 0 1 1-1.197-.121c.011-.122.04-.292.075-.5.191-1.127.59-3.472-.959-4.484-1.197-.781-2.518-1.515-4.064-1.595C3.76 1 1.921 5.843 1.186 8.748a.603.603 0 0 1-1.168-.295C.844 5.19 2.982-.257 8.002.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4709ywgr5cR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.856 2.146C2.85-.767 10.73-1.434 11.265 4.782l-8.43 6.34C1.154 9.879-1.324 5.334.857 2.147z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ouzkbhiucS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.318.238c2.415.636 3.929 2.494 4.153 5.098a.602.602 0 0 1-.548.651.593.593 0 0 1-.65-.548C11.04 2.75 9.371 1.76 8.01 1.402c-2.207-.581-5.037.209-6.052 1.69-1.92 2.805.335 7.04 1.84 8.153a.601.601 0 1 1-.715.968C1.332 10.917-1.502 6.019.966 2.412 2.28.492 5.58-.484 8.318.238z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "idqw8r428cT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.778 5.57 0 7.84C.773 4.783 3.888.222 7.019.02c2.192-.14 6.301.305 6.76 5.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v7apnk5ohcU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.98 6.118a.601.601 0 0 1-1.199.104c-.387-4.433-3.538-5.162-6.123-5.001-2.817.181-5.762 4.554-6.472 7.367a.603.603 0 0 1-1.168-.295C.854 4.987 4.135.241 7.581.021c2.053-.133 6.883.198 7.398 6.097z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qmr5tcqvzcV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.534.112c1.128-.51 6.46.892 7.61.736l-2.138 14.17C7.67 14.615.604 9.27.501 9.215.278 8.736.134 8.154.06 7.53-.13 5.933.138 4.053.72 2.868c.467-.95 1.828-2.31 2.814-2.756z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "geyattgxzcW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.857.493c1.134.193 2.425.412 2.807.359a.601.601 0 1 1 .163 1.192c-.543.07-1.558-.091-3.173-.365-1.413-.24-3.779-.64-4.272-.418-.832.375-2.105 1.624-2.522 2.472-.528 1.078-.776 2.857-.601 4.325.06.52.174.988.327 1.365l.427.316c5.371 3.977 7.17 5.082 7.71 5.282l.057.02a.603.603 0 0 1-.347 1.153c-.587-.177-1.986-1.054-4.403-2.771l-.756-.541a271.068 271.068 0 0 1-2.977-2.177c-.29-.214-.478-.353-.525-.386-.117-.062-.16-.13-.216-.25-.242-.52-.408-1.15-.492-1.87C-.138 6.499.15 4.49.78 3.203 1.321 2.102 2.802.655 3.886.164c.772-.349 2.469-.095 4.97.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9x12sjgv1cX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.489.11a.602.602 0 0 1 .143.839c-.67.946-1.423 2.08-2.22 3.281-3.357 5.06-7.535 11.357-11.494 12.841-.806.303-1.84.428-3.01.428-3.617 0-8.539-1.194-12.09-2.056l-.358-.088a.601.601 0 0 1 .283-1.168l.36.087c4.28 1.038 11.444 2.774 14.393 1.671 3.593-1.347 7.825-7.724 10.914-12.38.802-1.21 1.56-2.351 2.24-3.311A.602.602 0 0 1 29.49.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q7hktvx2ucY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.694.28c2.276-.631 6.329-.513 7.253 3.786l.74 4.915c.128 1.186-.717 2.013-2.064 2.335-1.955.467-5.765.29-7.558-.267C.134 10.14-.41 9.92.253 7.43.74 5.602 2.245.961 4.694.281z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9gcbmyrebcZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.661.844c1.275.771 2.106 2.016 2.468 3.699a.601.601 0 0 1-1.177.252c-.288-1.345-.932-2.328-1.914-2.921-1.408-.852-3.293-.77-4.59-.411-1.773.492-3.24 3.796-4.02 6.724-.528 1.978-.472 1.995 2.41 2.89 1.754.545 5.476.678 7.24.257.65-.156 1.723-.582 1.603-1.685a.603.603 0 0 1 .534-.664.606.606 0 0 1 .663.534c.155 1.432-.81 2.576-2.522 2.985-.809.193-1.933.284-3.116.284-1.729 0-3.583-.196-4.76-.562C.41 11.273-.522 10.83.266 7.876c.538-2.02 2.09-6.803 4.861-7.572.746-.208 3.351-.782 5.534.54z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "huv6egc39da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.924 1.178c1.336 1.158 2.52 2.53 2.457 4.39-.052 1.506-1.68 3.59-2.456 4.56L0 4.013C1.708.62 6.917-1.423 9.924 1.178z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qb56rtigqdb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.918 1.325c1.281 1.109 2.74 2.665 2.666 4.866-.054 1.559-1.411 3.446-2.587 4.915a.604.604 0 0 1-.846.094.603.603 0 0 1-.094-.846c.564-.704 2.278-2.845 2.324-4.204.058-1.683-1.104-2.923-2.25-3.916-1.046-.904-2.502-1.227-4.096-.913-2.06.408-4.028 1.84-4.896 3.564a.603.603 0 0 1-1.075-.54C1.107 2.274 3.358.624 5.8.141c1.968-.39 3.786.03 5.118 1.183z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rjkh7j39bdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.876 2.475 6.44 14.67C-3.853 12.131.774 1.406 2.863.39c1.96-.954 5.732-.118 6.013 2.085z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2zw36yo3gdd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.315.696c1.014.548 1.638 1.364 1.757 2.298a.602.602 0 0 1-1.194.153c-.087-.691-.665-1.139-1.135-1.393-1.19-.643-2.956-.745-4.019-.227-.92.448-2.832 3.93-2.48 7.25.321 3.026 2.32 5.012 5.94 5.905a.603.603 0 0 1-.289 1.17C1.709 14.57.309 11.366.048 8.903c-.385-3.635 1.63-7.72 3.15-8.46 1.396-.676 3.596-.571 5.117.252z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qrskhifgzde"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.006 0c6.072.01 10.834.128 11.32.348 1.861.838 9.806 9.296 10.234 11.555.802 4.245.584 10.324-4.687 10.701-3.565.255-10.295.513-17.02.688l-1.034.027c-8.094.201-15.943.277-18 .08-2.529-.243-5.92-.305-7.255-2.792C4.46 18.55 1.554 12.98.418 9.772.15 8.502-.255 5.61.218 3.957c.4-1.403 2.898-2.785 4.01-3.007C6.533.487 14.125.2 22.016.074l1.617-.023 1.615-.02 1.072-.01c1.425-.012 2.83-.019 4.184-.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3t92yobusdf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.175.436c1.965.885 10.097 9.459 10.576 11.992.357 1.884.954 6.568-1.194 9.357-.955 1.241-2.315 1.933-4.04 2.056-6.193.442-22.564.908-31.185.908-2.358 0-4.137-.035-4.97-.115l-.691-.062c-2.525-.219-5.667-.492-7.037-3.045a168.64 168.64 0 0 1-1.998-3.85l-.291-.584C2.265 14.92 1.093 12.42.45 10.609a.776.776 0 0 1-.022-.077C.125 9.084-.257 6.169.24 4.428.747 2.652 3.603 1.218 4.71.996c1.816-.364 10.829-.73 19.794-.9l1.097-.02c2.557-.043 5.086-.07 7.418-.075h1.47c5.12.009 9.02.136 9.686.435zm-12.202.815h-.99c-2.5.001-5.174.019-7.828.055l-1.06.015c-7.585.117-14.803.384-17.149.854-1.008.202-3.239 1.497-3.55 2.584-.428 1.501-.06 4.22.203 5.486 1.261 3.539 4.705 9.987 5.096 10.713 1.063 1.98 3.728 2.211 6.08 2.416l.703.063c.741.071 2.245.106 4.246.112h1.104c4.08-.007 9.752-.113 15.248-.268l1.028-.03c5.809-.17 11.292-.393 14.328-.61 1.387-.1 2.424-.62 3.172-1.59 1.283-1.667 1.644-4.807.965-8.4-.368-1.95-8.043-10.286-9.888-11.118-.558-.17-5.498-.277-11.708-.282z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6l5f5pv2edg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.941 0a.602.602 0 0 1 0 1.203c-4.892 0-9.328.023-13.76.047-4.426.024-8.847.048-13.715.048a57.69 57.69 0 0 1-1.76-.04c-2.602-.083-6.165-.193-7.773.89-1.119.755-1.519 1.994-1.657 2.9-.253 1.666.174 3.584 1.039 4.665a.603.603 0 0 1-.94.753C.299 9.12-.22 6.87.087 4.866c.25-1.64 1.002-2.924 2.175-3.716C4.19-.15 7.821-.037 10.744.056c.634.02 1.22.039 1.722.039 4.865 0 9.285-.024 13.709-.048C30.609.023 35.047 0 39.94 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kwznldcwhdh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.704 9.024 0 6.752C1.604-4.343 16.04-.467 14.704 9.024z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wn0dlzev6di"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.624.08c4.16.594 8.02 4.357 7.277 9.626a.601.601 0 1 1-1.19-.167c.637-4.526-2.681-7.757-6.257-8.268C5.58.869 1.95 2.229 1.197 7.436a.607.607 0 0 1-.681.51.6.6 0 0 1-.51-.682C.83 1.57 4.93-.446 8.624.081z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "944o7z3ykdj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.77.272.016.024.015.025.014.027a.601.601 0 0 1-.684.868 29.56 29.56 0 0 0-1.365-.02h-.572c-1.771.002-4.516.025-7.427.053l-.674.006-1.696.016c-5.092.05-10.567.101-14.658.106H5.51c-2.553-.004-4.392-.032-4.978-.1A.601.601 0 1 1 .67.082c.542.062 2.34.088 4.822.091h1.296C10.944.168 16.505.115 21.385.068 25.317.03 27.984.005 29.8.001h.894c2.613.006 2.944.081 3.077.27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n23uq3q2ldk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.367 10.486c-3.917.84-8.273.47-12.362.47L0 3.74c4.93-8.013 18.152-1.92 14.367 6.747z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fyjoy21tqdl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.71 1.106c3.352 1.751 5.83 5.59 3.81 10.214a.6.6 0 0 1-.426.348c-2.136.458-4.393.564-6.65.564-.99 0-1.981-.02-2.961-.04-.967-.02-1.93-.04-2.876-.04a.602.602 0 0 1 0-1.204c.955 0 1.925.021 2.9.04 3.036.064 6.172.127 9.028-.433 1.598-4.04-.794-7.031-3.38-8.383C7.951.498 3.474.81 1.112 4.647a.601.601 0 0 1-1.024-.63C2.835-.448 8.017-.826 11.711 1.106z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m337gsicmdm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11 1.6c2.093 1.716 4.65 5.69 2.39 8.163-2.169 2.37-4.952 1.67-8.417 1.473l-.636-.14C-3.074 9.42 1.439-4.676 9.109 1.602z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pxiasuivfdn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.09 1.744c1.562 1.277 3.316 3.688 3.48 5.962.087 1.198-.258 2.231-1.026 3.07-1.42 1.553-3.052 1.92-4.88 1.92-.783 0-1.6-.067-2.454-.137a59.913 59.913 0 0 0-1.56-.115.601.601 0 0 1-.392-.175.617.617 0 0 1-.385.012C1.269 11.793.235 10.35.034 8.32-.232 5.616 1.064 1.977 3.696.568c1.37-.733 3.589-1.122 6.394 1.175zM4.264 1.63C2.104 2.785 1.01 5.942 1.232 8.203c.088.894.463 2.462 1.99 2.926.099.03.183.083.251.15a.602.602 0 0 1 .21-.037h.034c.548.032 1.078.075 1.591.117 2.738.226 4.719.388 6.348-1.394.535-.586.776-1.317.715-2.172-.133-1.834-1.63-3.963-3.042-5.12C7.512 1.19 5.763.828 4.264 1.63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e423akvg8do"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.364 2.239c2.944 3.532 2.974 4.958 2.37 6.321-1.468 3.32-13.598 3.227-15.002 1.623l-.2-.2c-3.027-5.797 7.63-13.986 12.832-7.744z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6su19knm4dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.434 2.467c3.022 3.628 3.19 5.295 2.457 6.95-.75 1.695-3.47 2.441-5.62 2.769-1.264.192-2.686.29-4.067.29-2.867 0-5.563-.42-6.317-1.282a.672.672 0 0 1-.061-.084.606.606 0 0 1-.22-.235c-1.733-3.316.498-7.144 3.599-9.211 2.833-1.889 7.214-2.815 10.229.803zm-9.562.198C2.23 4.426.284 7.604 1.655 10.285c.05.03.096.07.137.116.599.684 5.096 1.235 9.297.595 2.581-.393 4.295-1.146 4.703-2.065.466-1.056.617-2.213-2.283-5.693-2.503-3.006-6.218-2.185-8.637-.573z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mi3xy85gddq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18.438c.92 3.22 1 5.195 1.095 7.481.031.76.064 1.562.13 2.465a.602.602 0 0 1-.556.644l-.045.002a.602.602 0 0 1-.6-.558c-.067-.917-.1-1.731-.132-2.504C.98 5.668.904 3.851.023.768A.6.6 0 0 1 .436.025a.595.595 0 0 1 .744.413z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7vw8iccgvdr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.56.001a.604.604 0 0 1 .641.558c.205 2.963.289 5.596.323 7.283.019.966.033 1.649.035 2.136l-.001.27a8.15 8.15 0 0 1-.016.497.7.7 0 0 1 .006.082h-.013c-.035.365-.115.416-.265.512a.599.599 0 0 1-.613.02.607.607 0 0 1-.312-.532v-.08l.001-.045.001-.196V10.217A148.084 148.084 0 0 0 .001.643.602.602 0 0 1 .561 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fgvklfctdds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.543c.05.49.114 1.014.18 1.548.21 1.702.427 3.462.214 4.634A.602.602 0 0 1 .41 6.51C.59 5.519.376 3.776.185 2.238.118 1.695.053 1.161.003.661A.601.601 0 1 1 1.2.543z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vcjbbjupedt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.806.326c1.912-.463 4.39-.55 6.08.522 1.941 1.228 2.516 4.3 3.259 6.231L.187 8.736c-.194-.84-.311-3.448.03-4.785C.684 2.118 1.97.771 3.806.326z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h6w1eo4rcdu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.81.943c1.707 1.082 2.445 3.355 3.039 5.182.155.48.304.937.46 1.343a.603.603 0 0 1-1.124.432 29.352 29.352 0 0 1-.48-1.403c-.562-1.729-1.198-3.689-2.539-4.537-1.29-.818-3.389-.985-5.617-.445-1.582.384-2.728 1.546-3.147 3.19-.306 1.2-.207 3.72-.027 4.5a.6.6 0 1 1-1.171.271c-.211-.91-.34-3.615.033-5.069.531-2.09 2-3.57 4.029-4.06C5.484.052 8.562-.481 10.81.943z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gckg37yivdv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.476 4.238c-3.46 8.151-8.534 6.01-8.665 5.949L0 2.944c2.263-4.46 12.6-3.712 10.476 1.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0u9wgnxc1dw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.855.656c1.913.89 2.577 2.548 1.776 4.435-1.392 3.28-3.213 5.37-5.416 6.215-.78.299-1.507.398-2.121.398a5.254 5.254 0 0 1-1.861-.323l-.065-.027-.01-.004a.602.602 0 0 1 .51-1.09c.007.003 1.406.602 3.172-.1 1.862-.739 3.438-2.602 4.684-5.54.547-1.289.15-2.257-1.177-2.874-2.287-1.062-6.871-.55-8.21 2.087A.601.601 0 1 1 .066 3.29C1.655.158 6.775-.778 9.855.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mmxrs50k3dx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.11 1.802c3.814 4.14-1.085 6.974-1.354 6.986l-9.954 4.914c-2.508-.144-4.153-.419-3.738-3.654.25-1.935 1.318-3.1 2.372-4.557 1.308-1.809 2.895-3.272 4.83-4.333 2.786-1.53 5.627-1.763 7.844.644z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2neispjjfdy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.154 2.001c1.93 2.096 1.772 3.9 1.3 5.044-.718 1.741-2.585 2.93-3.07 2.95-.329.034-.612-.241-.627-.573a.601.601 0 0 1 .458-.61c.288-.128 1.909-1.124 2.271-2.675.249-1.058-.16-2.175-1.216-3.321C13.474.866 11.08.688 8.156 2.292c-1.81.993-3.326 2.353-4.631 4.158-.152.21-.304.415-.454.615-.866 1.162-1.615 2.164-1.808 3.667-.138 1.075-.038 1.8.308 2.216.48.578 1.582.687 2.867.76a.602.602 0 0 1-.034 1.203l-.035-.001c-1.57-.09-2.934-.243-3.724-1.194-.578-.696-.76-1.693-.575-3.137.234-1.817 1.11-2.99 2.037-4.233.146-.197.295-.396.443-.601 1.393-1.926 3.085-3.442 5.028-4.507 3.42-1.879 6.386-1.615 8.576.763z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qsej3t5u2dz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.994.145c.559.478 1.124 1 1.695 1.527.957.882 1.947 1.795 2.926 2.52a.601.601 0 1 1-.716.967C3.868 4.395 2.853 3.46 1.873 2.556 1.313 2.04.759 1.528.21 1.057A.601.601 0 1 1 .994.145z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hpw2sd9t1dA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.978.132C2.521 1.37 3.9 3.191 4.906 4.52l.281.37a.603.603 0 0 1-.957.73l-.283-.375C2.98 3.967 1.651 2.215.224 1.071A.603.603 0 0 1 .978.132z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z7o61bdkwdB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.976.13c2.538 2.02 4.466 4.81 5.39 6.295a.603.603 0 0 1-1.022.635C3.843 4.647 1.977 2.464.227 1.072A.602.602 0 0 1 .977.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xdc8bbp9xdC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.773.026c2.425.723 6.117 5.398 6.963 7.1a.602.602 0 0 1-1.078.535C5.793 5.919 2.29 1.733.43 1.18A.6.6 0 0 1 .025.43.597.597 0 0 1 .773.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7khz7nbvdD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.872.217a.602.602 0 0 1-.077.847c-3.172 2.644-7.212 10.79-7.63 11.745a.619.619 0 0 1-.649.43.603.603 0 0 1-.508-.425c-.024-.078.005-.239.08-.467l-.021-.012a.692.692 0 0 1 .049-.073C.883 10.052 5.276 2.43 8.026.14a.6.6 0 0 1 .846.077z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a981oqujzdE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.542.129a.601.601 0 0 1 .1.845C5.709 4.684 3.48 8.737 1.325 12.658l-.196.357a.602.602 0 0 1-1.055-.579l.197-.358C2.45 8.115 4.704 4.016 7.698.228a.602.602 0 0 1 .844-.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31m8uh1u2dF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26.318c2.103-.536 5.462-.557 6.889 1.235 1.215 1.525 1.374 5.425-.003 6.918-.698.76-6.108.806-7.92.612l.065.064C2.74 9.018-.853 7.88.185 5.045.963 2.925 3.042.885 5.261.318z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k13ptlh5jdG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.22 1.784c1.353 1.698 1.567 5.968-.03 7.7-.666.723-3.54.893-5.779.893-.96 0-1.801-.03-2.303-.063a.582.582 0 0 1-.267.038c-1.089-.09-3.41-.672-4.398-2.219-.502-.787-.58-1.717-.222-2.69C1.1 3.04 3.36.941 5.71.341c2.548-.65 5.982-.475 7.51 1.443zm-7.21-.278c-1.96.5-3.919 2.33-4.66 4.351-.229.624-.193 1.157.108 1.628.611.959 2.159 1.48 3.18 1.632a.61.61 0 0 1 .253-.027c2.253.24 6.842.034 7.425-.432 1.174-1.274.98-4.85-.037-6.124C11.004.933 7.83 1.042 6.009 1.506z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "499zcqwxldH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.028 2.41c1.338.161 2.857.328 4.396.5l1.386.156c3.072.35 6.03.715 7.585 1.081 1.208.284 4.285.665 2.023 2.807-2.02 1.91-6.708 1.973-9.1 1.872A81.534 81.534 0 0 1 7.112 7.189C4.698 6.68 2.315 5.685 0 5.213L1.068 0c2.463.29 10.987 2.173 12.96 2.41z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qfjairidsdI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.694.007 44.583 6.91a.6.6 0 1 1-.184 1.19L.51 1.194A.601.601 0 1 1 .694.007z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2tsn4wpuudJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.533.204a.6.6 0 0 1-.054.849c-2.035 1.795-2.1 4.012-2.2 7.368-.02.649-.04 1.334-.076 2.06a.602.602 0 0 1-.6.571H.571a.602.602 0 0 1-.571-.63c.036-.719.056-1.395.075-2.037C.181 4.848.257 2.292 2.684.15a.602.602 0 0 1 .849.054z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h0wr2pz1hdK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.973.128c2.641 2.077 4.274 3.294 5.585 4.274 1.318.984 2.358 1.76 3.797 2.942a.6.6 0 1 1-.764.93C8.174 7.108 7.143 6.34 5.84 5.365A249.41 249.41 0 0 1 .23 1.074.602.602 0 0 1 .974.128z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tpx5oks94dL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.724 0c.333.006.598.28.593.611l-.114 7.125a.602.602 0 0 1-.601.592h-.01A.602.602 0 0 1 0 7.718L.114.591A.596.596 0 0 1 .724 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "61c5zmhiudM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.602 0c.328 0 .597.265.601.594l.088 7.982a.602.602 0 0 1-1.203.015L0 .609A.601.601 0 0 1 .594 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3k1ncdpc8dN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.945.108c3.836 2.673 11.03 7.877 16.13 12.693a.601.601 0 1 1-.826.874C11.207 8.913 4.066 3.75.258 1.095A.601.601 0 1 1 .945.108z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zb9f728owdO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.946.108a205.5 205.5 0 0 1 3.202 2.326c2.036 1.494 4.569 3.354 6.958 5.027a.6.6 0 1 1-.69.985c-2.4-1.68-4.94-3.544-6.98-5.042C2.074 2.403.946 1.575.258 1.094A.6.6 0 1 1 .946.109z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ii7pi0nvrdP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.091.08C6.72.118 8.4.158 9.551.158a.602.602 0 0 1 0 1.203c-1.165 0-2.855-.04-4.489-.08-1.626-.039-3.31-.079-4.46-.079A.602.602 0 0 1 .602 0c1.166 0 2.855.04 4.49.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "opqjblktodQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.996.147c1.48 1.286 2.392 2.124 4.064 3.736a.603.603 0 0 1-.418 1.035.6.6 0 0 1-.418-.169C2.57 3.154 1.67 2.325.207 1.056a.602.602 0 0 1 .79-.909z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dmvoskdjgdR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.891.001c.332.02.585.306.565.637-.857 14.22-6.502 26.286-15.49 33.108a.604.604 0 0 1-.844-.117.602.602 0 0 1 .116-.843c8.708-6.608 14.181-18.35 15.017-32.22a.6.6 0 0 1 .636-.565z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ydof46rddS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2.545c.072.746.141 1.509.213 2.292.523 5.706 1.172 12.81 3.287 23.21a.602.602 0 0 1-1.179.239C1.393 15.822.74 8.683.215 2.946.144 2.166.075 1.405.003.659A.603.603 0 0 1 .545.002.606.606 0 0 1 1.2.545z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4iagbnt8vdT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44 0c.332 0 .601.27.601.602 0 6.487-.109 18.402-.84 25.304a.602.602 0 0 1-1.198-.126C.73 18.932.838 7.066.838.602c0-.333.27-.602.602-.602z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "toye2yf5ydU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.866.003c.331.03.575.322.546.653-.758 8.32-2.1 16.502-4.225 25.746a.6.6 0 0 1-.72.45.6.6 0 0 1-.452-.72C2.127 16.942 3.462 8.812 4.213.547a.6.6 0 0 1 .653-.544z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z455ubzwvdV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.248.005a.602.602 0 0 1 .519.674c-.294 2.285-1.045 4.725-1.77 7.084-.283.917-.564 1.83-.816 2.726a.602.602 0 0 1-1.159-.325c.255-.907.54-1.828.824-2.755.711-2.31 1.446-4.7 1.728-6.884a.6.6 0 0 1 .674-.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ncoj5oi8fdW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.959.004c.33.032.571.326.54.657-1.033 10.445-4.217 16.189-7.39 21.177a.6.6 0 1 1-1.015-.645C3.189 16.326 6.295 10.723 7.3.543a.602.602 0 0 1 .658-.54z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9fhvi8r6dX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.087.003c.33.032.573.327.54.658-.8 8.104-7.166 22.422-10.505 28.16a.603.603 0 0 1-.822.218.601.601 0 0 1-.218-.822C3.373 22.56 9.646 8.474 10.429.543a.602.602 0 0 1 .658-.54z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tblxuglxndY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.834.003a.6.6 0 0 1 .578.623c-.024.646-.034 1.2-.042 1.699-.017 1.052-.032 1.884-.174 2.783A.603.603 0 0 1 .008 4.92c.129-.816.142-1.57.16-2.615C.175 1.799.184 1.236.21.58.222.25.486-.032.834.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k9ixe4u6ndZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.698.002c.33.03.574.323.544.654-.095 1.052.004 2.75.101 4.113a.601.601 0 0 1-.557.643l-.043.002a.601.601 0 0 1-.6-.558C.037 3.359-.059 1.679.044.547A.605.605 0 0 1 .698.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ka66vjfawea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.314.193a.6.6 0 0 1-.034.85c-.177.164-.363.343-.562.537-2.887 2.8-8.261 8.012-30.73 9.08-1.76.083-3.45.123-5.065.123C8.733 10.783.53 2.694.17 2.326a.601.601 0 0 1 .86-.843c.023.024 2.344 2.333 7.898 4.46 5.137 1.967 14.164 4.172 28.003 3.515C58.946 8.411 64.305 3.214 66.88.716c.208-.201.4-.387.583-.556a.602.602 0 0 1 .85.033z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mzrdhlehbeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.622.305.015.029.027.06a.603.603 0 0 1-.75.81 12.795 12.795 0 0 0-.78-.02h-.473c-3.347.01-12.307.23-20.38.427l-.992.024-.991.025-.99.024c-7.251.176-14.22.34-17.31.353l-.396.001a.602.602 0 0 1 0-1.203c2.777 0 9.791-.163 17.186-.342l.987-.024.99-.024.496-.012.99-.024C31.902.148 37.441.013 40.345.001h.673c2.173.007 2.487.11 2.604.304z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w1l6e8miwec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.313.015c.302.07.507.36.466.667-.034.256-.052.393-.73.483l-.006.023a.806.806 0 0 1-.052-.015c-.816.1-2.517.14-6.107.227a3365.121 3365.121 0 0 1-18.784.387l-1.034.019c-6.537.116-12.79.209-15.831.213h-.233c-.66 0-1.147-.004-1.422-.015A.601.601 0 0 1 .623.803C4.306.93 42.216.148 44.038.015a.62.62 0 0 1 .275-.001z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0qhkaxvza)",
    transform: "translate(-143 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mucpynmcwb)",
    transform: "translate(143.39 464.954)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h67.695v37.715H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qopxdqf2pc)",
    transform: "translate(302.084 355.858)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h31.304v53.703H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#len0rrvrvd)",
    transform: "translate(311.863 346.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h43.499v47.98H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sbij8larve)",
    transform: "translate(282.807 428.593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h45.202v44.796H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#65lpmant4f)",
    transform: "translate(306.817 424.591)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h4.424v4.1H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9m9eo4omrg)",
    transform: "translate(321.666 395.633)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h37.376v90.567H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sd5pl3vhqh)",
    transform: "translate(248.829 472.166)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h109.33v43.19H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17lrubxkoi)",
    transform: "translate(234.437 451.794)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h49.12v13.3H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tnj5noay7j)",
    transform: "translate(234.62 481.636)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h3.196v5.082H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ktx58p5qak)",
    transform: "translate(234.016 481.035)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.402v6.285H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0gl2hwwxbl)",
    transform: "translate(166.813 456.254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h26.762v24.976H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u6bzdi4idm)",
    transform: "translate(299.132 404.681)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h35.374v53.836H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4tjqh1ztjn)",
    transform: "translate(279.372 451.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h38.601v28.973H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#npeqiw38xo)",
    transform: "translate(192.069 455.27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h116.653v38.277H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u6vt00tywp)",
    transform: "translate(154.972 478.706)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h10.687v11.267H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bmfi2ef3nq)",
    transform: "translate(172.863 464.029)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h29.69v8.57H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crg960ze5r)",
    transform: "translate(154.668 471.431)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h11.014v9.343H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64moxgxc5s)",
    transform: "translate(157.695 506.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A4236",
    d: "M0 0h40.72v21.315H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ymiwdx9ptt)",
    transform: "translate(279.781 417.414)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h28.678v41.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wzcl0x8rtu)",
    transform: "translate(222.229 449.094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h13.147v17.593H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7jty2urpv)",
    transform: "translate(215.274 398.973)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h45.365v58.08H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qspxkwof2w)",
    transform: "translate(308.467 514.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h72.89v45.525H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dxipsswizx)",
    transform: "translate(373.848 515.688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h6.854v12.406H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zo5riny6fy)",
    transform: "translate(317.267 502.83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h54.069v23.473H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ucohhuz3jz)",
    transform: "translate(214.89 510.85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h86.696v49.327H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pwkm62axzA)",
    transform: "translate(248.901 449.495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h3.354v3.038H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fke14zpjcB)",
    transform: "translate(268.92 381.382)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h46.063v44.375H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vdcptchtnC)",
    transform: "translate(266.914 358.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h22.49v27.133H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4aq5ayxexD)",
    transform: "translate(143.123 463.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h68.586v35.858H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j8201ynhbE)",
    transform: "translate(143.115 489.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h68.453v13.68H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j0sz7nb7iF)",
    transform: "translate(157.037 506.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h42.107v22.59H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#he3svxwctG)",
    transform: "translate(143.056 489.664)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h15.99v31.607H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j3eihqt6vH)",
    transform: "translate(149.016 495.061)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h14.938v30.527H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8od1jg7evI)",
    transform: "translate(159.71 499.965)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h8.957v27.528H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j9bkvy52zJ)",
    transform: "translate(337.72 408.143)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h21.382v77.66H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#elmiaafdtK)",
    transform: "translate(337.12 407.544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h22.58v78.867H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qs2622tnlL)",
    transform: "translate(164.522 501.16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h2.139v8.051H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x3rmoheyoM)",
    transform: "translate(155.232 498.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h5.013v14.536H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yk83n7h2aN)",
    transform: "translate(265.776 484.89)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h92.984v30.746H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e9axkc1uO)",
    transform: "translate(343.83 514.618)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.426v16.04H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8g5kbl80P)",
    transform: "translate(268.636 514.657)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.005v16.04H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w6pcn8u3aQ)",
    transform: "translate(235.908 455.285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h43.63v9.22H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7wseq49cR)",
    transform: "translate(236.442 481.483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h14.195v23.144H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66dwzlqveS)",
    transform: "translate(220.243 503.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h28.556v18.466H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2z9599xvkT)",
    transform: "translate(166.761 456.358)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h25.355v24.691H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9gd4thvshU)",
    transform: "translate(166.158 455.756)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h26.56v25.894H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#05fe79ekjV)",
    transform: "translate(301.587 366.259)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.465v43.836H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bpw1wi0dbW)",
    transform: "translate(309.254 371.605)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.47v4.68H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gapcfeyuqX)",
    transform: "translate(305.284 380.695)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.481v3.876H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pj6oikyy4Y)",
    transform: "translate(307.342 351.485)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h18.193v15.632H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s7sj0vfv9Z)",
    transform: "translate(320.926 371.501)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.51v14.716H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6atytxk2uaa)",
    transform: "translate(321.99 377.113)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.313v3.457H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#60clemkjyab)",
    transform: "translate(324.532 351.477)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h22.585v54.029H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#32bl2qf3eac)",
    transform: "translate(333.994 346)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vah76inoaad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h21.955v20.852H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5tnynfiwnae)",
    transform: "translate(313.037 379.094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.359v3.475H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j6xvv930uaf)",
    transform: "translate(292.731 399.898)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h22.96v26.438H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#578oeen77ag)",
    transform: "translate(289.67 409.632)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.022v7.937H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#978ccubxyah)",
    transform: "translate(292.078 412.386)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.385v2.513H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39o8an6ftai)",
    transform: "translate(298.594 415.988)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.441v2.249H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w1dinvxtaaj)",
    transform: "translate(306.302 418.476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.336v2.157H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#moq0hrppgak)",
    transform: "translate(302.54 418.562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.81v3.385H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6x5taop58al)",
    transform: "translate(300.1 421.574)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.018v2.348H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#czkn83kc8am)",
    transform: "translate(299.749 403.679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.907v5.414H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oufv0374ban)",
    transform: "translate(302.837 402.075)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.821v7.653H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am9s3w892ao)",
    transform: "translate(306.406 402.398)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.933v7.847H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f6yxqt9jap)",
    transform: "translate(309.173 403.836)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.911v6.861H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2clc4ku2kaq)",
    transform: "translate(311.429 406.977)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.962v4.672H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31ztmr79dar)",
    transform: "translate(282.18 429.39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.267v20.866H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33wne4mkcas)",
    transform: "translate(293.917 421.588)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h14.398v14.36H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4lh5ibq70at)",
    transform: "translate(293.315 420.986)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h15.601v15.559H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tosxha3gkau)",
    transform: "translate(285.846 417.393)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.067v7.487H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4fu60vcvoav)",
    transform: "translate(221.157 447.827)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h31.856v10.033H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pw1evnm8kaw)",
    transform: "translate(224.677 446.482)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h24.795v9.344H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g9ibmcmazax)",
    transform: "translate(225.554 401.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h11.535v55.274H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ajcf00bxtay)",
    transform: "translate(224.953 400.968)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.738v56.477H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0cgyvjbp6az)",
    transform: "translate(236.703 398.933)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h9.006v17.221H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap4tyqw29aA)",
    transform: "translate(236.101 398.33)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.206v18.425H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hvbfe6mmzaB)",
    transform: "translate(250.081 411.386)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h8.946v23.266H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5yeeex1pnaC)",
    transform: "translate(249.48 410.785)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.152v24.468H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0suc5thyaD)",
    transform: "translate(239.487 410.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h10.386v45.822H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j34omsv44aE)",
    transform: "translate(238.892 410.276)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.582v47.027H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d7llo2n8raF)",
    transform: "translate(242.16 427.443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h18.626v28.91H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1x87k7f66aG)",
    transform: "translate(241.559 426.84)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h19.828v30.116H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#86w2xm1mbaH)",
    transform: "translate(215.858 411.635)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h11.91v44.142H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pihch0y1aaI)",
    transform: "translate(215.265 411.031)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.104v45.348H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x1vj5j2w9aJ)",
    transform: "translate(227.659 414.914)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h7.253v41.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g5rrtre1vaK)",
    transform: "translate(227.06 414.312)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.44v42.891H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dq1f69yppaL)",
    transform: "translate(221.284 452.524)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h3.38v15.016H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1u9mroc02aM)",
    transform: "translate(305.8 424.252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.226v5.478H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ihw6xyhgeaN)",
    transform: "translate(279.02 423.644)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.509v28.615H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5t5qvba4aO)",
    transform: "translate(283.33 442.076)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.704v2.09H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2mpmlpf25aP)",
    transform: "translate(290.689 448.878)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h5.105v10.675H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mjh3xyqpqaQ)",
    transform: "translate(290.084 448.277)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.311v11.882H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wrv340xcwaR)",
    transform: "translate(292.156 428.156)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.134v5.6H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w7iefar01aS)",
    transform: "translate(314.536 404.088)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h18.737v6.608H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91nbv9r1yaT)",
    transform: "translate(275.413 380.61)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.24v22.176H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2te1qrn73aU)",
    transform: "translate(279.239 384.154)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h9.94v1.5H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rrssjrqazaV)",
    transform: "translate(288.046 361.464)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.39v23.669H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6752ywty3aW)",
    transform: "translate(276.942 360.808)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.306v22.13H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tse872jzuaX)",
    transform: "translate(278.12 360.838)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.303v1.63H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#891aqnenxaY)",
    transform: "translate(268.677 357.806)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.566v28.436H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uumfo2ilnaZ)",
    transform: "translate(280.742 363.933)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.932v1.309H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zgorztb9lba)",
    transform: "translate(280.502 366.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h7.02v1.346H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0xthv01xnbb)",
    transform: "translate(280.967 369.282)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.313v1.406H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqzu3yf0lbc)",
    transform: "translate(280.338 372.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.82v1.398H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xpzydcs65bd)",
    transform: "translate(280.415 375.415)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.125v1.276H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2sdxs7hg0be)",
    transform: "translate(280.38 378.149)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.325v1.31H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3gd1d1h3nbf)",
    transform: "translate(280.533 380.801)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.725v1.295H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5j7mmm3iubg)",
    transform: "translate(271.516 360.804)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.007v2.685H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zhjwdys3ebh)",
    transform: "translate(271.593 363.797)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.1v2.58H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ihjybtyr6bi)",
    transform: "translate(271.471 366.83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.979v1.99H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emrtf00olbj)",
    transform: "translate(271.424 369.447)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.778v2.096H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#va50y9ecobk)",
    transform: "translate(271.3 372.467)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.86v1.89H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4iitojnuzbl)",
    transform: "translate(271.08 375.534)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.944v1.584H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3v6xfuypubm)",
    transform: "translate(271.25 378.38)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.73v1.411H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jx4olbhd2bn)",
    transform: "translate(271.009 380.991)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.724v1.332H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lmsfl9um7bo)",
    transform: "translate(266.55 357.878)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.286v2.367H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lr2eqqn0sbp)",
    transform: "translate(266.429 359.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.108v27.35H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#930l9ftdcbq)",
    transform: "translate(268.228 385.518)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.693v21.765H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#171126abobr)",
    transform: "translate(313.744 421.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h20.153v26.077H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xvmpigj8lbs)",
    transform: "translate(313.143 420.798)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h21.355v27.279H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ux7mfvfyubt)",
    transform: "translate(248.945 496.443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h19.363v18.485H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dle5mabdubu)",
    transform: "translate(301.403 445.185)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.677v14.206H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vd52kq001bv)",
    transform: "translate(294.4 447.063)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h34.63v26.616H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68hbugwkdbw)",
    transform: "translate(314.436 406.76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h18.905v6.743H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#su3zvv0tfbx)",
    transform: "translate(313.49 444.256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h20.652v1.282H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ddy585li8by)",
    transform: "translate(269.81 406.087)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.523v19.273H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2zm0lrrb9bz)",
    transform: "translate(277.315 401.275)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.691v13.832H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w976htm9mbA)",
    transform: "translate(287.775 428.572)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h14.782v17.696H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5wd3dzaewbB)",
    transform: "translate(192.31 460.097)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h109.16v22.11H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#szt4d7rrabC)",
    transform: "translate(191.708 459.495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h110.363v23.312H-.001V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#orxxg2gumbD)",
    transform: "translate(278.602 450.398)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.36v6.357H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#udlvabp3nbE)",
    transform: "translate(235.219 452.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h18.257v6.297H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eshjjw6r3bF)",
    transform: "translate(278.335 455.284)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h37.104v25.49H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n1y9s1qp4bG)",
    transform: "translate(314.312 472.448)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.598v8.22H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j0pkx6bpmbH)",
    transform: "translate(300.4 477.766)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h9.224v4.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n0gmhp7b6bI)",
    transform: "translate(332.147 403.31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.723v30.937H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1l657e0rgbJ)",
    transform: "translate(297.443 405.934)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.457v3.309H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jkb6c6wghbK)",
    transform: "translate(240.791 510.317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h4.013v5.239H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yo331zhgbbL)",
    transform: "translate(174.207 474.828)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.213v3.441H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5m6n7jl91bM)",
    transform: "translate(153.963 473.522)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.58v15.173H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vn1j7jneebN)",
    transform: "translate(155.351 487.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.137v3.112H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#osx1p34yrbO)",
    transform: "translate(164.286 473.656)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.339v14.786H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pnf4kio9rbP)",
    transform: "translate(153.963 470.849)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.699v6.216H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#97cw7m3fqbQ)",
    transform: "translate(236.536 451.299)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h47.102v9.09H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heg5eoamibR)",
    transform: "translate(156.836 484.177)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.617v2.411H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ge3h7zw3pbS)",
    transform: "translate(156.066 478.517)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.45v4.073H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zmml1iovpbT)",
    transform: "translate(233.739 481.56)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h3.903v5.965H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fca9vbh12bU)",
    transform: "translate(313.531 531.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h64.15v29.274H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r21cfv6fobV)",
    transform: "translate(313.48 523.933)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h64.875v25.918H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fnb4ctum2bW)",
    transform: "translate(310.128 530.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.717v17.778H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hq8xsx9bubX)",
    transform: "translate(376.472 530.302)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.967v16.703H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4rg7a5ndrbY)",
    transform: "translate(308.39 511.853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q5t8gb1pmbZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h73.92v29.007H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m24utc98ica)",
    transform: "translate(308.991 509.603)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h72.718v27.804H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4rg7a5ndrbY)",
    transform: "translate(308.39 509.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q5t8gb1pmbZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h73.92v29.007H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vq907r2gxcb)",
    transform: "translate(313.184 516.222)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h66.049v21.584H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x56i82956cc)",
    transform: "translate(366.804 512.236)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h12.566v15.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6803v0ayfcd)",
    transform: "translate(366.203 511.634)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.769v16.816H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ywxeyfeoce)",
    transform: "translate(310.117 514.482)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h4.422v16.442H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el74r1okzcf)",
    transform: "translate(309.512 513.881)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.63v17.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1ly36zhucg)",
    transform: "translate(311.8 510.271)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h63.777v21.082H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3rp1roebgch)",
    transform: "translate(311.201 509.669)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h64.978v22.286H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trzdviuycci)",
    transform: "translate(312.729 502.188)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h60.398v23.36H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w0hl9bf2rcj)",
    transform: "translate(312.13 501.586)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h61.599v24.564H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zhexe56egck)",
    transform: "translate(217.007 524.807)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h81.69v35.143H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6arvit53acl)",
    transform: "translate(216.409 524.212)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h82.889v36.332H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58lsojxnvcm)",
    transform: "translate(214.398 523.649)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.368v23.993H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kudpry8o0cn)",
    transform: "translate(292.196 528.995)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h6.671v10.39H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nv1xq0lwvco)",
    transform: "translate(217.263 524.352)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h20.474v23.298H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#io0p1yjxkcp)",
    transform: "translate(297.984 516.364)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.51v23.689H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nc75ndp5icq)",
    transform: "translate(286.983 540.824)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.405v15.84H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tryuikk8ncr)",
    transform: "translate(215.055 501.405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h86.918v37.397H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cxfy6qebdcs)",
    transform: "translate(214.45 500.809)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h88.124v38.59H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av65qmty9ct)",
    transform: "translate(286.089 516.562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h13.32v21.503H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pla8e7ugccu)",
    transform: "translate(217.991 505.501)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h39.752v27.237H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3sbc8d2qvcv)",
    transform: "translate(297.676 515.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.536v7.219H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3d4w0fryncw)",
    transform: "translate(217.663 498.785)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h41.977v33.119H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vavdquf09cx)",
    transform: "translate(217.063 498.183)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h43.176v34.322H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09scnvtjacy)",
    transform: "translate(313.705 493.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h57.774v21.778H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kfhwyiq4scz)",
    transform: "translate(313.102 493.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h58.98v22.985H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5vis4r9oscA)",
    transform: "translate(218.507 492.794)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h36.221v28.622H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5697dl10gcB)",
    transform: "translate(217.906 492.19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h37.422v29.826H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kfzycoqfzcC)",
    transform: "translate(244.566 503.863)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h54.975v29.777H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vd23nrejrcD)",
    transform: "translate(243.964 503.276)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h56.176v30.966H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6jckowm9kcE)",
    transform: "translate(242.136 508.959)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h54.65v29.55H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5101xtsvycF)",
    transform: "translate(241.534 508.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h55.855v30.756H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y971710zicG)",
    transform: "translate(241.343 515.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h19.46v14.249H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zrgnctwmvcH)",
    transform: "translate(240.74 514.556)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h20.658v15.456H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ioqxvrsd5cI)",
    transform: "translate(220.194 504.462)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h36.81v23.26H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f5voyasucJ)",
    transform: "translate(241.072 511.691)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h19.46v14.25H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iep2wfacqcK)",
    transform: "translate(240.469 511.085)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h20.658v15.456H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6f2iws4edcL)",
    transform: "translate(241.177 509.527)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h17.814v13.741H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r1d2a1foscM)",
    transform: "translate(240.576 508.944)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h19.02v14.923H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lfbnyhvd9cN)",
    transform: "translate(281.552 504.057)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h10.73v7.294H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#odus6e0slcO)",
    transform: "translate(280.951 503.456)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.933v8.496H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my84u2dszcP)",
    transform: "translate(266.982 501.249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h13.154v7.998H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kfpax6wv8cQ)",
    transform: "translate(266.38 500.646)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h14.355v9.202H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4709ywgr5cR)",
    transform: "translate(263.804 506.67)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h11.265v11.123H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ouzkbhiucS)",
    transform: "translate(263.198 506.064)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.473v12.33H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idqw8r428cT)",
    transform: "translate(272.997 506.753)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h13.778v7.84H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v7apnk5ohcU)",
    transform: "translate(272.395 506.153)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h14.982v9.042H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qmr5tcqvzcV)",
    transform: "translate(261.452 516.553)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A4236",
    d: "M0 0h11.145v15.017H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#geyattgxzcW)",
    transform: "translate(260.851 515.953)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.347v16.219H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9x12sjgv1cX)",
    transform: "translate(221.349 498.518)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h29.743v17.499H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q7hktvx2ucY)",
    transform: "translate(257.145 525.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h12.7v11.584H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9gcbmyrebcZ)",
    transform: "translate(256.552 524.838)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.894v12.788H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#huv6egc39da)",
    transform: "translate(282.154 510.747)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A4236",
    d: "M0 0h12.383v10.128H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qb56rtigqdb)",
    transform: "translate(281.553 510.146)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.587v11.332H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rjkh7j39bdc)",
    transform: "translate(267.36 512.354)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h8.876v14.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2zw36yo3gdd)",
    transform: "translate(266.76 511.758)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.077v15.868H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qrskhifgzde)",
    transform: "translate(314.885 482.588)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h53.908v23.514H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3t92yobusdf)",
    transform: "translate(314.284 481.951)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h55.107v24.75H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6l5f5pv2edg)",
    transform: "translate(323.282 492.897)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h40.543v10.691H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kwznldcwhdh)",
    transform: "translate(337.223 472.083)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h14.792v9.024H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wn0dlzev6di)",
    transform: "translate(336.621 471.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h15.993v10.224H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#944o7z3ykdj)",
    transform: "translate(330.14 498.543)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h33.886v1.377H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n23uq3q2ldk)",
    transform: "translate(330.71 476.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h15.039v11.038H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fyjoy21tqdl)",
    transform: "translate(330.108 475.706)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.248v12.232H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m337gsicmdm)",
    transform: "translate(321.662 479.568)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h12.381v11.485H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pxiasuivfdn)",
    transform: "translate(321.062 478.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h13.584v12.695H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e423akvg8do)",
    transform: "translate(341.406 479.203)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h16.045v11.263H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6su19knm4dp)",
    transform: "translate(340.799 478.589)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h17.255v12.475H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mi3xy85gddq)",
    transform: "translate(333.115 476.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.406v11.03H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7vw8iccgvdr)",
    transform: "translate(337.326 476.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.559v11.434H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fgvklfctdds)",
    transform: "translate(341.136 476.83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.681v7.219H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vcjbbjupedt)",
    transform: "translate(274.69 513.53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h13.145v8.736H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h6w1eo4rcdu)",
    transform: "translate(274.088 512.924)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h14.348v9.942H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gckg37yivdv)",
    transform: "translate(282.507 518.674)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h10.762v10.485H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0u9wgnxc1dw)",
    transform: "translate(281.906 518.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h11.964v11.704H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mmxrs50k3dx)",
    transform: "translate(268.765 521.107)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h16.558v13.702H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2neispjjfdy)",
    transform: "translate(268.163 520.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h17.76v14.91H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qsej3t5u2dz)",
    transform: "translate(268.456 528.195)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.859v5.277H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hpw2sd9t1dA)",
    transform: "translate(271.56 525.284)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.31v5.856H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z7o61bdkwdB)",
    transform: "translate(273.873 522.83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.456v7.344H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xdc8bbp9xdC)",
    transform: "translate(276.992 521.21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h7.799v7.994H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7khz7nbvdD)",
    transform: "translate(244.085 508.944)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h9.012v13.242H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a981oqujzdE)",
    transform: "translate(248.136 509.746)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.771v13.327H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31m8uh1u2dF)",
    transform: "translate(272.591 529.606)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h13.12v9.18H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k13ptlh5jdG)",
    transform: "translate(271.991 529.001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h14.312v10.377H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#499zcqwxldH)",
    transform: "translate(255.77 534.408)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h30.226v8.855H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qfjairidsdI)",
    transform: "translate(240.73 531.267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h45.786v8.114H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2tsn4wpuudJ)",
    transform: "translate(234.07 454.305)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h3.683v11.052H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h0wr2pz1hdK)",
    transform: "translate(320.652 471.485)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h10.575v8.41H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tpx5oks94dL)",
    transform: "translate(210.392 482.723)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h1.317v8.328H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61c5zmhiudM)",
    transform: "translate(143 482.054)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h1.291v9.185H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3k1ncdpc8dN)",
    transform: "translate(341.824 395.29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h17.264v13.84H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zb9f728owdO)",
    transform: "translate(332.414 400.37)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.363v8.555H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ii7pi0nvrdP)",
    transform: "translate(332.415 395.024)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.153v1.362H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#opqjblktodQ)",
    transform: "translate(263.306 481.376)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h5.244v4.918H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dmvoskdjgdR)",
    transform: "translate(195.133 489.663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h16.457v33.868H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ydof46rddS)",
    transform: "translate(169.368 501.827)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h4.712v26.768H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4iagbnt8vdT)",
    transform: "translate(178.379 502.228)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h2.041v26.445H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#toye2yf5ydU)",
    transform: "translate(184.607 501.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h5.414v26.868H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z455ubzwvdV)",
    transform: "translate(192.527 499.722)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h3.772v10.928H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ncoj5oi8fdW)",
    transform: "translate(198.061 494.609)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h8.501v22.117H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9fhvi8r6dX)",
    transform: "translate(190.12 497.215)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h11.63v29.121H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tblxuglxndY)",
    transform: "translate(183.904 501.692)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h1.412v5.615H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k9ixe4u6ndZ)",
    transform: "translate(173.838 502.228)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h1.345v5.414H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ka66vjfawea)",
    transform: "translate(311.83 527.392)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h68.473v10.783H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mzrdhlehbeb)",
    transform: "translate(324 518.236)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h43.712v2.038H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w1l6e8miwec)",
    transform: "translate(323.4 508.512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A08",
    d: "M0 0h44.784v2.02H0V0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanLaundryBaby);
export default __webpack_public_path__ + "static/media/woman_laundry_baby.f79a59a17e1139994a20f1ccde80c087.svg";
export { ForwardRef as ReactComponent };